import {
  Component,
  ChangeDetectorRef,
  Inject,
  OnInit,
  AfterViewInit,
  inject,
} from '@angular/core';
import { PaymentOrdersService } from '../../shared/services/payment-orders.service';
import { UserService } from '../../shared/services/getUser.service';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  MatDialogRef,
  MatDialog,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDividerModule } from '@angular/material/divider';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, DateAdapter } from '@angular/material/core';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import {
  NGX_STRIPE_VERSION,
  NgxStripeModule,
  STRIPE_PUBLISHABLE_KEY,
  STRIPE_OPTIONS,
  LazyStripeAPILoader,
  WindowRef,
  DocumentRef,
  StripeElementsService,
  StripeService,
  StripeFactoryService,
} from 'ngx-stripe';
import { StripeElementsOptions } from '@stripe/stripe-js';
import { environment } from '../../../environments/environment';
import { MercantilPaymentService } from '../../shared/services/mercantil-payment.service';
import { PaymentService } from '../../shared/services/payment.service';
import { CurrencyService } from '../../shared/services/currency.service';
import { ServiceCenterService } from '../../shared/services/service-center.service';
import { StripeTokenService } from '../../shared/services/stripe-token.service';
import { CountryService } from '../../shared/services/country.service';
import { StripeCardComponent } from 'ngx-stripe';
import { TranslateModule } from '@ngx-translate/core';
import { SuccessPaymentDialogComponent } from '../../modals/success-payment-dialog.component';
import { InvalidLinkDialogComponent } from '../../modals/invalid-link-dialog.component';
import { PendingVerificationDialogComponent } from '../../modals/pending-verification-dialog.component';
import { ViewChild } from '@angular/core';
import { Account } from '../../models/account.model';
import { TranslateService } from '@ngx-translate/core';
import { CustomDateAdapter } from '../../shared/services/custom-date-adapter';
import { BankAccountsService } from '../../shared/services/bank-accounts.service';
import { SidneyCustomFlowService } from '../../shared/services/sidney-custom-flow.service';
import {
  safeParseJson,
  isServiceCenterInactive,
  SERVICE_UNAVAILABLE_MESSAGE,
} from '../../shared/utils/restrictions.util';

@Component({
  selector: 'app-payment',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatSelectModule,
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxStripeModule,
    TranslateModule,
    MatDialogModule,
  ],
  providers: [
    {
      provide: MatDialogRef,
      useValue: {}, // Provide a mock or default value for MatDialogRef
    },
    { provide: DateAdapter, useClass: CustomDateAdapter },
    StripeFactoryService,
    { provide: NGX_STRIPE_VERSION, useValue: '20.7.0' },
    {
      provide: STRIPE_PUBLISHABLE_KEY,
      useFactory: () => {
        return localStorage.getItem('stripePublishableKey');
      },
    },
    { provide: STRIPE_OPTIONS, useValue: {} },
    // Remove apiVersion override to avoid unsupported [basil] error
    StripeElementsService,
    StripeService,
    LazyStripeAPILoader,
    WindowRef,
    DocumentRef,
  ],
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
})
export class PaymentComponent implements OnInit, AfterViewInit {
  public amount = 0;
  private readonly serviceCenterService: ServiceCenterService =
    inject(ServiceCenterService);
  private readonly stripeService: StripeService = inject(StripeService);
  private readonly stripeTokenService: StripeTokenService =
    inject(StripeTokenService);
  private readonly stripeFactory: StripeFactoryService =
    inject(StripeFactoryService);
  private readonly paises: CountryService = inject(CountryService);
  private readonly dialog = inject(MatDialog);
  // Stripe instance created via factory using publishable key from service-center
  stripe!: import('@stripe/stripe-js').Stripe | undefined;
  // Capture ngx-stripe-card component instance
  @ViewChild(StripeCardComponent) stripeCardRef!: StripeCardComponent;
  // Flag to indicate the Stripe Element has been mounted and is ready
  stripeReady: boolean = false;
  private successDialogOpened = false;
  selectedCurrency: string = 'USD';
  method = '';
  checkStripe!: Boolean;
  checkPaypal!: Boolean;
  checkTransfer!: Boolean;
  checkCash!: Boolean;
  valueStripeId!: String;
  formPaymenCard!: FormGroup;
  formPaymenBank!: FormGroup;
  showPayButton = true;
  // dataSource = new MatTableDataSource();
  //  formPaymenCard!: FormGroup;
  // formPaymenBank!: FormGroup;
  externalId!: string;
  listCountry: any;
  Lang: number = 1; // localStorage.getItem('language') === 'es' ? 1 : 0;
  process = true;
  check = false;
  mountCuot = 0;
  cuot = 2;
  currencySelect: any = [];
  currentCurrency: any;
  auxcurrency: any;
  specialTaxpayer =
    sessionStorage.getItem('specialTaxpayer') == 'true' ? true : false;
  // Hidden by default; only enabled when MercantilButton flag is explicitly 'true' in localStorage
  showMercantilButton = false;

  accountCurrency: any = {
    id: '00000000-0000-0000-0000-000000000001',
    isoCode: 'USD',
    name: 'Dolar',
  };
  tasa = 0;
  /**
   * Raw `value` returned by /api/v1/exchange-rate, sent as `PaymentExchangeRate`
   * with every payment. Unlike `tasa` it is kept for USD too (where `tasa` is 0
   * because no conversion is applied), so each payment records the rate in effect.
   */
  exchangeRateValue = 0;
  /**
   * Monotonic token for currency changes. Every currency switch increments it and
   * only the newest one is allowed to commit state, so slow responses from a
   * previously selected currency can no longer overwrite the current rate/price.
   */
  private currencyChangeSeq = 0;
  /** True while a currency change (currency data + exchange rate) is still in flight. */
  currencyChangeInFlight = false;
  /**
   * True when the selected currency has no usable exchange rate (request failed,
   * offline, or not loaded yet). Amounts must not be displayed nor paid in that state.
   */
  rateUnavailable = false;
  arrayFee = new Array();
  dateYear = new Array();
  dateMonth = [
    {
      value: 1,
      name: 'January.texto',
    },
    {
      value: 2,
      name: 'February.texto',
    },
    {
      value: 3,
      name: 'March.texto',
    },
    {
      value: 4,
      name: 'April.texto',
    },
    {
      value: 5,
      name: 'May.texto',
    },
    {
      value: 6,
      name: 'June.texto',
    },
    {
      value: 7,
      name: 'July.texto',
    },
    {
      value: 8,
      name: 'August.texto',
    },
    {
      value: 9,
      name: 'September.texto',
    },
    {
      value: 10,
      name: 'October.texto',
    },
    {
      value: 11,
      name: 'November.texto',
    },
    {
      value: 12,
      name: 'December.texto',
    },
  ];
  dateDay = new Array();
  dateAccount!: Account;
  // @Output() continueConfirmation = new EventEmitter<any>();
  mostrarSpinner: boolean = true;
  dataBank: any[] = [];
  bankName: any[] = [];
  currency: any;
  fecha = new Date();
  fechaStar!: string;
  price: number = 0;
  // Fetched payment order and computed display fields
  paymentOrder: any = null;
  // flag to indicate the order was already paid on load
  paymentOrderPaid: boolean = false;
  displayUnitPrice: number | null = 0;
  displayTotal: number | null = 0;
  // User related display fields
  userFullName: string = '';
  userEmail: string = '';
  file: any;
  buttonDisable = true;
  showfile = false;
  deleteFileString!: string;
  formData!: FormData;
  montopago: any;
  totalwithtasa: any;
  paypalClientId = '';
  paymentOrderid: any;
  originId: any;
  transaccionId: any;

  igtfTax = 0;
  igtfFlag = false;

  errorflag = false;

  multiCurrency = true;

  // Stripe error info for UI display (code and translated message)
  stripeErrorCode: string | null = null;
  stripeErrorMessage: string | null = null;
  // Aggregated missing required fields message for mobile payment
  mobileValidationSummary: string | null = null; // no longer rendered in template, kept for potential logging
  // Aggregated missing required fields message for transfer form
  transferValidationSummary: string | null = null;

  //Pago movil
  checkPagomovil: boolean = true; // Boolean flag for mobile payments
  typeOfBank: any; //tipo de banco
  prefixPhoneNumber: any;
  phoneNumber: any;
  bankSelected: any;
  Otp: any;
  PrefixDni = 'V';
  dni: any;
  // Validation flags for mobile payment fields (make keys non-optional to avoid undefined type issues)
  mobileValidationErrors: {
    phoneNumber: string | null;
    prefixPhoneNumber: string | null;
    bankSelected: string | null;
    dni: string | null;
    Otp: string | null;
  } = {
    phoneNumber: null,
    prefixPhoneNumber: null,
    bankSelected: null,
    dni: null,
    Otp: null,
  };
  // Validation flags for transfer form fields
  transferValidationErrors: {
    numberReference: string | null;
    BankName: string | null;
    accountHolder: string | null;
    dateComplet: string | null;
    file: string | null;
  } = {
    numberReference: null,
    BankName: null,
    accountHolder: null,
    dateComplet: null,
    file: null,
  };
  listOfBanks: any[] = [];
  IVA: any;
  ISLR: any;
  inputHabilitadoIva: boolean = false;
  inputHabilitadoIslr: boolean = false;
  handlesTaxWithholdings = false;
  // store as boolean to avoid 'undefined' / string issues
  useFirstDayRate: boolean = localStorage.getItem('useFirstDayRate') === 'true';
  firstDayRate = false;
  maxDate = new Date(); // Set max date to today

  elementsOptions: any = {
    locale: 'es',
  }; // Start in Spanish; keep in sync with selected language

  // Real translation service injected (removed stub)
  constructor(
    private matSnackBar: MatSnackBar,
    private dialogRef: MatDialogRef<PaymentComponent>,
    private cdr: ChangeDetectorRef, // Added ChangeDetectorRef to trigger change detection
    private fb: FormBuilder,
    private paymentOrdersService: PaymentOrdersService,
    private userService: UserService,
    private mercantilPaymentService: MercantilPaymentService,
    private paymentService: PaymentService, // newly added service for payment creation
    private currencyService: CurrencyService,
    @Inject(STRIPE_PUBLISHABLE_KEY) private injectedStripePk: string,
    public translate: TranslateService,
    private dateAdapter: DateAdapter<Date>,
    private _bankAccountsService: BankAccountsService,
    private sidneyCustomFlowService: SidneyCustomFlowService,
  ) {
    // alias for legacy references in CrearTarjeta logic
    this._mobilePaymentService = this.paymentService;
    // Initialize translate language from localStorage 'lang' or fallback to 'es'
    const storedLang = localStorage.getItem('lang');
    const initial =
      storedLang && ['es', 'en'].includes(storedLang) ? storedLang : 'es';
    console.log(
      '[PaymentComponent][i18n] Initial storedLang=',
      storedLang,
      ' -> using lang=',
      initial,
    );
    this.translate.use(initial);
    // Register Spanish locale data once when needed
    if (initial === 'es') {
      try {
        registerLocaleData(localeEs);
      } catch (e) {
        /* ignore */
      }
    }
    // Set date adapter locale so mat-datepicker weekdays reflect current language
    try {
      this.dateAdapter.setLocale(initial);
    } catch (e) {
      /* ignore */
    }
    this.elementsOptions.locale = initial as any;
    // React to successful load / language switch
    this.translate.onLangChange.subscribe((ev) => {
      console.log(
        '[PaymentComponent][i18n] onLangChange ->',
        ev.lang,
        'PaymentDetail=',
        this.translate.instant('PaymentDetail.texto'),
      );
    });
    // Diagnostic: attempt to translate a few sample keys immediately
    const sampleKeys = [
      'PaymentMobile.texto',
      'CreditCard.texto',
      'MakePayment.texto',
      'SelectBank.texto',
    ];
    sampleKeys.forEach((k) => {
      console.log(
        '[PaymentComponent][i18n] instant(',
        k,
        ')=',
        this.translate.instant(k),
      );
    });
    console.log(
      '[PaymentComponent][i18n] currentLang after use() =',
      this.translate.currentLang,
    );

    // Debug: log which publishable key the injected ngx-stripe provider was configured with
    try {
      console.log(
        '[PaymentComponent] injected STRIPE_PUBLISHABLE_KEY provider =',
        this.injectedStripePk,
      );
      console.log(
        '[PaymentComponent] localStorage.stripePublishableKey =',
        localStorage.getItem('stripePublishableKey'),
      );
      // Use the injected provider value ONLY if localStorage is empty
      try {
        const current = localStorage.getItem('stripePublishableKey');
        if (this.injectedStripePk && !current) {
          localStorage.setItem(
            'stripePublishableKey',
            String(this.injectedStripePk),
          );
          console.log(
            '[PaymentComponent] localStorage was empty. Persisted injected STRIPE_PUBLISHABLE_KEY to localStorage',
          );
        } else if (
          this.injectedStripePk &&
          current &&
          this.injectedStripePk !== current
        ) {
          console.log(
            '[PaymentComponent] localStorage already has a key. NOT overriding with injected provider value.',
            { current, injected: this.injectedStripePk },
          );
        }
      } catch (e) {
        console.warn(
          '[PaymentComponent] unable to persist injected publishable key to localStorage',
          e,
        );
      }
    } catch (err) {
      console.warn(
        '[PaymentComponent] error logging injected STRIPE_PUBLISHABLE_KEY',
        err,
      );
    }
  }

  switchLanguage(lang: string) {
    if (!['es', 'en'].includes(lang)) return;
    localStorage.setItem('lang', lang);
    this.translate.use(lang);
    console.log('[PaymentComponent][i18n] switchLanguage ->', lang);
    this.elementsOptions.locale = lang as any;
    // Register Spanish locale data if switching to Spanish
    if (lang === 'es') {
      try {
        registerLocaleData(localeEs);
      } catch (e) {
        /* ignore */
      }
    }
    // Update datepicker locale for weekday/month names
    try {
      this.dateAdapter.setLocale(lang);
    } catch (e) {
      /* ignore */
    }
  }

  ngOnInit(): void {
    // Ensure theme colors are restored from localStorage on direct refresh
    this.getPaletteColor();
    console.log(
      '[PaymentComponent][i18n] ngOnInit currentLang=',
      this.translate.currentLang,
    );
    console.log(
      '[PaymentComponent][i18n] Translation test PaymentDetail.texto =',
      this.translate.instant('PaymentDetail.texto'),
    );

    // Re-apply branding persisted by ShortLinkLoader (title, favicon)
    try {
      this.applyStoredBranding();
    } catch (e) {
      console.warn('[PaymentComponent] applyStoredBranding failed', e);
    }

    // Force-read any preloaded forced currency (id + iso) persisted by short-link loader
    try {
      const forcedCurrencyId = localStorage.getItem('accountcurrency');
      const forcedIso = localStorage.getItem('accountcurrency_iso');
      if (forcedCurrencyId) {
        this.accountCurrency.id = forcedCurrencyId;
        this.currency = forcedCurrencyId; // internal reference id
      }
      if (forcedIso) {
        this.accountCurrency.isoCode = forcedIso;
        this.selectedCurrency = forcedIso; // ensure UI selects VES if that's forced
      }
      if (forcedCurrencyId || forcedIso) {
        console.log('[PaymentComponent] Applied forced currency from storage', {
          id: forcedCurrencyId,
          iso: forcedIso,
        });
      }
    } catch (e) {
      console.warn('[PaymentComponent] failed applying forced currency', e);
    }

    try {
      const mc = localStorage.getItem('multiCurrency');
      if (mc !== null) {
        this.multiCurrency = mc === 'true';
      }
      if (!this.multiCurrency) {
        const baseCurId = localStorage.getItem('baseCurrencyId');
        if (baseCurId) {
          this.currency = baseCurId;
          this.accountCurrency.id = baseCurId;
          // Note: sync selection will happen in getCurrency/changeCurrency
        }
      }
      console.log(
        '[PaymentComponent] multiCurrency status:',
        this.multiCurrency,
      );
    } catch (e) {
      console.warn('[PaymentComponent] failed applying multiCurrency check', e);
    }

    this.checkPagomovil = true;
    // Ensure PaymentMobile button is enabled by default
    // Initial sync of payment method visibility flags from localStorage.
    // These may be written by ShortLinkLoader just before navigating here.
    this.syncPaymentMethodFlagsFromStorage('ngOnInit');

    // When coming from ShortLinkLoader, account-level flags (stripe, transferAndDeposit,
    // settingsMobile, MercantilButton) are fetched asynchronously via getAccountById.
    // That call may complete shortly AFTER this component's ngOnInit runs, so we
    // perform a second sync after a short delay to pick up the final values and
    // hide payment methods if all of them are false.
    setTimeout(() => {
      this.syncPaymentMethodFlagsFromStorage('delayed');
    }, 700);

    // Let ngx-stripe manage the Stripe instance internally

    // If a publishable key was stored from the service-center response, create a Stripe instance
    try {
      // Prefer the injected provider value (already persisted in constructor) but fall back to localStorage
      const publishable =
        ((this.injectedStripePk && String(this.injectedStripePk)) ||
          localStorage.getItem('stripePublishableKey')) ??
        '';
      if (publishable) {
        // StripeFactoryService.create returns a StripeInstance or similar depending on ngx-stripe
        // store it to `this.stripe` for use when creating tokens
        // Use a try/catch to avoid breaking the flow if creation fails
        this.stripe = this.stripeFactory.create(publishable) as any;
        console.log('[PaymentComponent] Stripe instance created via factory');
      } else {
        console.log(
          '[PaymentComponent] no stripePublishableKey in localStorage, will rely on injected StripeService',
        );
      }
    } catch (err) {
      console.error(
        '[PaymentComponent] error creating Stripe instance from factory:',
        err,
      );
    }

    // Set default phone prefix so the select isn't empty
    if (!this.prefixPhoneNumber) {
      this.prefixPhoneNumber = '58412';
    }

    // Initialize minimal bank transfer form group
    this.formPaymenBank = this.fb.group({
      numberReference: [
        '',
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(15),
          Validators.pattern(/^[A-Za-z0-9]{10,15}$/),
        ],
      ],
      BankName: ['', [Validators.required]],
      accountHolder: ['', [Validators.required]],
      dateComplet: [null, [Validators.required]],
    });

    // Fetch the payment order then use its externalId to fetch the user and token
    console.log('[PaymentComponent] Fetching payment order...');
    this.paymentOrdersService.getByCorrelative().subscribe(
      (order: any) => {
        console.log('[PaymentComponent] fetched order:', order);
        console.log('[PaymentComponent] PRICE INFO FROM FETCHED ORDER:', {
          amount: order?.amount,
          unitAmount: order?.unitAmount,
          amountInForeignCurrency: order?.amountInForeignCurrency,
          tasa: this.tasa,
          quantity: order?.quantity,
        });
        // If the backend returns 204 No Content, HttpClient will call the success
        // path with a null/undefined body. Treat that as an invalid link and show
        // the invalid dialog to the user.
        if (order == null) {
          this.mostrarSpinner = false;
          try {
            this.dialog.open(InvalidLinkDialogComponent, {
              disableClose: true,
              width: '360px',
            });
          } catch (e) {
            console.warn(
              '[PaymentComponent] failed to open invalid link dialog on 204/null response',
              e,
            );
          }
          return;
        }
        // If early-check already set the paid flag, skip re-initializing
        if (this.paymentOrderPaid) {
          this.mostrarSpinner = false;
          console.log(
            '[PaymentComponent] paymentOrderPaid already true, skipping full init',
          );
          return;
        }
        this.paymentOrder = order;
        if (order?.paymentOrderStatus === 4) {
          this.paymentOrderPaid = true;
          this.openSuccessDialog();
        } else if (order?.paymentOrderStatus === 1) {
          // Order is pending verification
          console.log(
            '[PaymentComponent] full fetch: order pending verification, opening pending dialog',
          );
          try {
            this.dialog.open(PendingVerificationDialogComponent, {
              disableClose: true,
              width: '360px',
            });
          } catch (e) {
            console.warn(
              '[PaymentComponent] failed to open pending verification dialog on full fetch',
              e,
            );
          }
        }
        if (order) {
          // set base fields: price MUST come from amountInForeignCurrency (no fallback to unitAmount)
          this.price = order.amountInForeignCurrency ?? 0;
          this.paymentOrderid = order.id;
          this.originId = order.serviceRequestId;
          this.updateDisplayPrices();

          // If the order has no externalId, try to retrieve it from the service request
          const serviceRequestId =
            order.serviceRequestId || this.originId || '';
          if (!serviceRequestId) {
            this.mostrarSpinner = false;
            console.warn(
              '[PaymentComponent] No externalId and no serviceRequestId available on order, skipping user fetch',
            );
          } else {
            console.log(
              '[PaymentComponent] No externalId on order; fetching customer account using cid from localStorage',
            );
            // Use the cid persisted by the short-link loader instead of querying the service-request
            const scid = localStorage.getItem('scid') || '';
            const cid = localStorage.getItem('cid') || '';
            const customerName = localStorage.getItem('fullName') || 'Customer';

            if (!cid) {
              console.warn(
                '[PaymentComponent] cid not available in localStorage, skipping customer account lookup',
              );
              return;
            }

            if (!scid) {
              console.warn(
                '[PaymentComponent] scid not available in localStorage, cannot lookup customer account',
              );
              return;
            }

            console.log(
              '[PaymentComponent] using localStorage.cid for account lookup:',
              cid,
            );

            this.userService.getCustomerAccountByUserId(scid, cid).subscribe(
              (cust: any) => {
                console.log(
                  '[PaymentComponent] customer account lookup response (short-link flow):',
                  cust,
                );
                const candidate =
                  (cust && cust.result && cust.result[0]) || cust || null;
                const acct = candidate?.accountId ?? cust?.accountId ?? null;
                const accountOwner =
                  candidate?.accountOwner ||
                  candidate?.customer ||
                  customerName;
                const correlative = candidate?.correlative ?? '';
                // set specialTaxpayer from customer account response if present
                try {
                  const specialFromCandidate =
                    candidate?.specialTaxpayer ??
                    candidate?.members?.[0]?.specialTaxpayer ??
                    null;
                  if (
                    specialFromCandidate !== null &&
                    specialFromCandidate !== undefined
                  ) {
                    this.specialTaxpayer = Boolean(specialFromCandidate);
                    sessionStorage.setItem(
                      'specialTaxpayer',
                      String(this.specialTaxpayer),
                    );
                    console.log(
                      '[PaymentComponent] specialTaxpayer set from customer account response:',
                      this.specialTaxpayer,
                    );
                  }
                } catch (e) {
                  console.warn(
                    '[PaymentComponent] error setting specialTaxpayer from customer account response',
                    e,
                  );
                }

                if (accountOwner) {
                  localStorage.setItem('fullName', accountOwner);
                  console.log(
                    '[PaymentComponent] Stored fullName in localStorage (serviceRequest flow)',
                    accountOwner,
                  );
                } else if (customerName) {
                  localStorage.setItem('fullName', customerName);
                  console.log(
                    '[PaymentComponent] Stored fullName from service request into localStorage (serviceRequest flow)',
                    customerName,
                  );
                }

                // Use email persisted by the short-link loader (or candidate email as fallback).
                try {
                  const candidateEmail =
                    (candidate && (candidate.email || candidate.account)) ||
                    candidate?.members?.[0]?.email ||
                    null;
                  const storedEmail =
                    localStorage.getItem('email') || candidateEmail;
                  if (storedEmail) {
                    console.log(
                      '[PaymentComponent] Using stored email (short-link or candidate), skipping email-dos lookup:',
                      storedEmail,
                    );
                    const token = localStorage.getItem('auth_token');
                    if (token) {
                      console.log(
                        '[PaymentComponent] auth_token already present in localStorage',
                      );
                      // showServiceCenterId now invoked in ShortLinkLoaderComponent after short-link resolution.
                      // (Removed direct call here per request.)
                    } else {
                      console.log(
                        '[PaymentComponent] no auth_token in localStorage, proceeding without calling email-dos',
                      );
                    }
                  } else {
                    console.log(
                      '[PaymentComponent] No email present (candidate or localStorage), skipping auth token retrieval',
                    );
                  }
                } catch (e) {
                  console.warn(
                    '[PaymentComponent] error handling stored/candidate email',
                    e,
                  );
                }

                if (correlative != null && correlative !== '') {
                  localStorage.setItem('tokenCorrelative', String(correlative));
                  console.log(
                    '[PaymentComponent] Stored tokenCorrelative in localStorage (serviceRequest flow)',
                    correlative,
                  );
                }

                if (acct) {
                  localStorage.setItem('accountid', acct);
                  console.log(
                    '[PaymentComponent] Stored accountid in localStorage (serviceRequest flow)',
                    acct,
                  );
                } else {
                  console.warn(
                    '[PaymentComponent] account id not found in customer lookup response (serviceRequest flow)',
                  );
                }

                // update UI fields
                this.userFullName = accountOwner || customerName;
                this.mostrarSpinner = false;
                this.cdr.detectChanges();
              },
              (err: any) => {
                this.mostrarSpinner = false;
                console.error(
                  '[PaymentComponent] error fetching customer account by user id (serviceRequest flow):',
                  {
                    status: err?.status,
                    statusText: err?.statusText,
                    message: err?.message,
                    body: err?.error,
                  },
                );
              },
            );
          }
        }
      },
      (err: any) => {
        this.mostrarSpinner = false;
        console.error('[PaymentComponent] fetching payment order failed', err);
        try {
          this.dialog.open(InvalidLinkDialogComponent, {
            disableClose: true,
            width: '360px',
          });
        } catch (e) {
          console.warn(
            '[PaymentComponent] failed to open invalid link dialog on full fetch',
            e,
          );
        }
      },
    );
  }

  /**
   * Read persisted branding values from localStorage and apply them to the document.
   * Keys used: 'appName' and 'fav'
   */
  private applyStoredBranding() {
    try {
      const appName = localStorage.getItem('appName');
      if (appName) {
        document.title = appName;
      }
      const fav = localStorage.getItem('fav');
      if (fav) {
        let link: HTMLLinkElement | null =
          document.querySelector("link[rel~='icon']");
        if (!link) link = document.querySelector("link[rel='shortcut icon']");
        if (!link) {
          link = document.createElement('link');
          link.rel = 'icon';
          document.getElementsByTagName('head')[0].appendChild(link);
        }
        link.href = fav;
      }
    } catch (e) {
      console.warn('[PaymentComponent] failed to apply stored branding', e);
    }
  }

  ngAfterViewInit(): void {
    // Log the ViewChild once view is initialized to help debug if the card mounted
    console.log(
      '[PaymentComponent] ngAfterViewInit stripeCardRef=',
      this.stripeCardRef,
    );
    try {
      console.log(
        '[PaymentComponent] stripeCardRef.element=',
        (this.stripeCardRef as any)?.element,
      );
    } catch (e) {
      console.warn('[PaymentComponent] stripeCardRef.element access threw', e);
    }
    // Defer all state-changing calls to next macrotask to avoid NG0100
    setTimeout(() => {
      this.isMercantilActive();
      this.getCurrency();
      this.showAccountPayment();
      this.loadDataBank(); // Load mobile payment banks on initial load
      this.selectDate();
      // this.BuildFormPaymenCard();
      // this.BuildFormPaymenBank();
      this.showCountry();
      this.checkAccountStripe();
      // Only call changeCurrency if a currency was pre-selected; otherwise let getCurrency/load set it
      if (this.currency) {
        this.changeCurrency();
      }
      try {
        this.cdr.detectChanges();
      } catch (e) {
        /* ignore */
      }
    }, 0);
  }
  getPaletteColor() {
    let primaryColor = localStorage.getItem('ColorP');
    let secondaryColor = localStorage.getItem('ColorS');

    if (!primaryColor || !secondaryColor) {
      primaryColor = '#29abe2';
      secondaryColor = '#2795c4';
    }

    document.documentElement.style.setProperty(
      '--theme-color-primary',
      primaryColor,
    );
    document.documentElement.style.setProperty(
      '--theme-color-secondary',
      secondaryColor,
    );
  }

  /**
   * Wait for localStorage key 'useFirstDayRate' to be set (short timeout)
   * and return its boolean value. Falls back to false after timeout.
   */
  private readUseFirstDayRate(
    timeoutMs: number = 800,
    intervalMs: number = 120,
  ): Promise<boolean> {
    return new Promise((resolve) => {
      const start = Date.now();
      const check = () => {
        const v = localStorage.getItem('useFirstDayRate');
        if (v !== null) {
          const b = v === 'true';
          this.useFirstDayRate = b;
          resolve(b);
          return;
        }
        if (Date.now() - start >= timeoutMs) {
          this.useFirstDayRate = false;
          resolve(false);
          return;
        }
        setTimeout(check, intervalMs);
      };
      check();
    });
  }

  showCountry() {
    this.paises.getCountry().subscribe(
      (countryResp: any) => {
        // Normalize response shapes: accept Array, { response: [...] }, { data: [...] }
        let countries: any[] = [];
        if (!countryResp) {
          countries = [];
        } else if (Array.isArray(countryResp)) {
          countries = countryResp;
        } else if (Array.isArray(countryResp.response)) {
          countries = countryResp.response;
        } else if (Array.isArray(countryResp.data)) {
          countries = countryResp.data;
        } else if (Array.isArray(countryResp.country)) {
          countries = countryResp.country;
        } else {
          // Try to find the first array inside the object
          const arr = Object.values(countryResp).find((v) =>
            Array.isArray(v),
          ) as any[];
          countries = arr || [];
        }

        // Ensure language selection has a sane default
        const langKey = localStorage.getItem('language');
        if (langKey === 'es') {
          this.Lang = 1;
        } else if (langKey === 'en') {
          this.Lang = 0;
        } else if (typeof this.Lang !== 'number') {
          this.Lang = 1; // default to Spanish indexing used elsewhere
        }

        // Filter countries by language if the field exists, otherwise keep all
        try {
          this.listCountry = countries.filter((datos: any) => {
            if (datos == null) return false;
            // support both `language` numeric flags and `lang`/`isoCode` names
            if (typeof datos.language !== 'undefined')
              return datos.language === this.Lang;
            if (typeof datos.lang !== 'undefined')
              return datos.lang === (this.Lang === 1 ? 'es' : 'en');
            if (typeof datos.isoCode !== 'undefined')
              return datos.isoCode === (this.Lang === 1 ? 'es' : 'en');
            return true;
          });
        } catch (err) {
          console.warn('[PaymentComponent] showCountry: filtering failed', err);
          this.listCountry = countries;
        }
      },
      (err: any) => {
        console.warn('[PaymentComponent] showCountry failed', err);
        this.listCountry = [];
      },
    );
  }
  selectDate() {
    let myDate = new Date();
    let year = myDate.getFullYear();
    const currentMonth = myDate.getMonth() + 1;
    for (let i = 2035; i >= year + 1; --i) {
      this.dateYear.push(i);
    }
    this.monthDay(currentMonth, year);
    this.dateYear.push(year);
    this.dateYear.reverse();
  }
  monthDay(mes: any, año: any) {
    this.dateDay = [];
    let day = new Date(año, mes, 0).getDate();
    for (let i = 1; i <= day; i++) {
      this.dateDay.push(i);
    }
  }

  private updateDisplayPrices() {
    if (!this.paymentOrder) return;
    const prevUnit = this.displayUnitPrice;
    const prevTotal = this.displayTotal;

    // amountInForeignCurrency is already the order total, so the Total field
    // mirrors the service price and matches the amount charged
    const baseTotal = this.getBaseTotal();
    if (this.selectedCurrency === 'USD') {
      // USD: show the foreign amount directly
      this.rateUnavailable = false;
      this.displayUnitPrice = baseTotal;
      this.displayTotal = baseTotal;
    } else if (this.tasa && this.tasa > 0) {
      // Non-USD with a loaded tasa: apply it to the foreign amount
      this.rateUnavailable = false;
      const convertedTotal = baseTotal * this.tasa;
      this.displayUnitPrice = convertedTotal;
      this.displayTotal = convertedTotal;
    } else {
      // Non-USD without a tasa (still loading, request failed or offline): never fall
      // back to the unconverted amount. Doing so showed the USD figure labelled as the
      // local currency and let the user pay that amount.
      this.rateUnavailable = true;
      this.displayUnitPrice = null;
      this.displayTotal = null;
    }

    console.log('[PaymentComponent] updateDisplayPrices', {
      selectedCurrency: this.selectedCurrency,
      tasa: this.tasa,
      rateUnavailable: this.rateUnavailable,
      prevUnit,
      prevTotal,
      newUnit: this.displayUnitPrice,
      newTotal: this.displayTotal,
      sourceForeignAmount: this.paymentOrder.amountInForeignCurrency,
      quantity: this.paymentOrder.quantity,
    });
  }

  private getHandlesTaxWithholding() {
    let _handlesTaxWithholding = false;
    if (this.IVA != 0 || this.IVA != null) {
      _handlesTaxWithholding = true;
    }
    if (this.ISLR != 0 || this.ISLR != null) {
      _handlesTaxWithholding = true;
    }
    if (this.ISLR == null && this.IVA == null) {
      _handlesTaxWithholding = false;
    }

    return _handlesTaxWithholding;
  }

  /**
   * Read account-level restriction flags from localStorage and update the
   * booleans that control which payment methods are visible.
   *
   * Flags written by ShortLinkLoader / service-center account:
   *  - 'stripe'             -> this.checkStripe
   *  - 'transferAndDeposit' -> this.checkTransfer
   *  - 'settingsMobile'     -> this.checkPagomovil
   *  - 'MercantilButton'    -> this.showMercantilButton
   *
   * Called on ngOnInit and again shortly after to catch async writes that
   * happen after navigation from ShortLinkLoader.
   */
  private syncPaymentMethodFlagsFromStorage(source: string = 'init'): void {
    // Mercantil instant payment button visibility
    try {
      const mercantilFlag = localStorage.getItem('MercantilButton');
      if (mercantilFlag !== null) {
        // Only show when explicitly set to 'true'; hide for any other value
        this.showMercantilButton = mercantilFlag === 'true';
      }
    } catch (e) {
      console.warn(
        '[PaymentComponent] Failed to read MercantilButton from localStorage',
        e,
      );
    }

    // Stripe credit card availability
    try {
      const stripeFlag = localStorage.getItem('stripe');
      if (stripeFlag !== null) {
        this.checkStripe = stripeFlag === 'true';
      } else {
        this.checkStripe = true;
      }
    } catch {
      this.checkStripe = true;
    }

    // Bank transfer / deposit availability
    try {
      const transferFlag = localStorage.getItem('transferAndDeposit');
      if (transferFlag !== null) {
        this.checkTransfer = transferFlag === 'true';
      } else {
        this.checkTransfer = true;
      }
    } catch {
      this.checkTransfer = true;
    }

    // Mobile payment (C2P) availability
    try {
      const c2pFlag = localStorage.getItem('settingsMobile');
      if (c2pFlag !== null) {
        this.checkPagomovil = c2pFlag === 'true';
      }
    } catch {
      // keep existing value on error
    }

    console.log('[PaymentComponent] syncPaymentMethodFlagsFromStorage', {
      source,
      stripe: this.checkStripe,
      transfer: this.checkTransfer,
      c2p: this.checkPagomovil,
      mercantil: this.showMercantilButton,
    });
  }

  changeMethod(value: string) {
    console.log('On click detected');
    console.log('changeMethod called with value:', value); // Debugging log
    if (!this.checkStripe && value === 'credit') {
      console.log('Credit method disabled due to checkStripe condition');
      return;
    }

    this.method = value;
    console.log('Updated method to:', this.method); // Debugging log

    // Trigger change detection to ensure UI updates
    this.cdr.detectChanges();

    // After changing the method, wait a tick and log the stripe card reference
    setTimeout(() => {
      console.log(
        '[PaymentComponent] post-change stripeCardRef=',
        this.stripeCardRef,
      );
      try {
        console.log(
          '[PaymentComponent] post-change stripeCardRef.element=',
          (this.stripeCardRef as any)?.element,
        );
      } catch (err) {
        console.warn(
          '[PaymentComponent] post-change stripeCardRef.element access threw',
          err,
        );
      }
    }, 100);

    // If the credit method was selected, start waiting for the Stripe element to mount
    if (value === 'credit') {
      this.waitForStripeMount();
    }

    if (value == 'paypal') {
      this.showPayButton = false;
      this.PayWithPaypal();
    } else {
      this.showPayButton = true;
    }
  }

  // Simple validator for currency ids to avoid persisting or using invalid values
  private isValidCurrencyId(id: any): boolean {
    if (!id) return false;
    const s = String(id).trim();
    if (!s) return false;
    if (s === 'undefined' || s === 'null') return false;
    return true;
  }

  /**
   * Poll a few times until the Stripe card element has been mounted.
   * This sets `stripeReady` to true and triggers change detection so the UI
   * can stop showing a loading placeholder.
   */
  private waitForStripeMount(retries: number = 10, interval = 150) {
    this.stripeReady = false;
    let attempts = 0;
    const check = () => {
      attempts++;
      const hasElement = !!(this.stripeCardRef as any)?.element;
      console.log('[PaymentComponent] waitForStripeMount attempt', attempts, {
        hasElement,
      });
      if (hasElement) {
        this.stripeReady = true;
        this.cdr.detectChanges();
        console.log(
          '[PaymentComponent] Stripe element mounted, stripeReady=true',
        );
        return;
      }
      if (attempts >= retries) {
        console.warn('[PaymentComponent] Stripe element did not mount in time');
        this.stripeReady = false;
        this.cdr.detectChanges();
        return;
      }
      setTimeout(check, interval);
    };
    // give the view a small tick to mount the child component first
    setTimeout(check, 50);
  }

  // File selection handler for transfer proof upload
  getFile(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input?.files?.[0] ?? null;
    if (file) {
      // Enforce max 10MB
      const maxBytes = 10 * 1024 * 1024;
      if (file.size > maxBytes) {
        this.matSnackBar.open(
          this.translate.instant('FileTooLarge.texto') ||
            'File must be <= 10MB',
          '',
          { duration: 5000 },
        );
        // reset input value
        try {
          (event.target as HTMLInputElement).value = '';
        } catch {}
        this.file = null as any;
        this.showfile = false;
        return;
      }
      this.file = file;
      this.showfile = true;
      this.deleteFileString = 'Eliminar archivo';
      console.log('Selected file:', file.name, 'size=', file.size);
    } else {
      console.log('No file selected');
    }
  }

  // Validate transfer form before submission
  isTransferValid(): boolean {
    this.transferValidationErrors = {
      numberReference: null,
      BankName: null,
      accountHolder: null,
      dateComplet: null,
      file: null,
    };
    this.transferValidationSummary = null;
    let valid = true;
    const t = (k: string) => this.translate.instant(k);
    const missing: string[] = [];
    const ref = String(
      this.formPaymenBank?.value?.numberReference ?? '',
    ).trim();
    const bank = String(this.formPaymenBank?.value?.BankName ?? '').trim();
    const acct = String(this.formPaymenBank?.value?.accountHolder ?? '').trim();
    const date = this.formPaymenBank?.value?.dateComplet ?? null;

    if (!ref) {
      missing.push(t('ReferenceNumber.texto'));
      valid = false;
    }
    if (!bank) {
      missing.push(t('ReceivingBankName.texto'));
      valid = false;
    }
    if (!acct) {
      missing.push(t('AccountHolder.texto'));
      valid = false;
    }
    if (!date) {
      missing.push(t('TransferDate.texto'));
      valid = false;
    }

    if (missing.length) {
      // Single snackbar: prefijo + lista de campos faltantes
      const prefix =
        this.translate.currentLang === 'es'
          ? 'Complete los siguientes campos:'
          : 'Please complete the following fields:';
      this.transferValidationSummary = `${prefix} ${missing.join(', ')}`;
      this.matSnackBar.open(this.transferValidationSummary, '', {
        duration: 4000,
      });
      // Skip further format validations when required fields missing
      return false;
    }

    // Detailed validations only if ref present
    if (ref) {
      if (ref.length < 10 || ref.length > 15) {
        const msg =
          (t('ReferenceNumber.texto') || 'Reference number') + ' (10-15)';
        this.matSnackBar.open(msg, '', { duration: 4000 });
        valid = false;
      } else if (!/^[0-9]{10,15}$/.test(ref)) {
        const msg = /\D/.test(ref)
          ? t('ReferenceMustBeNumbers.texto') ||
            'Reference must contain only numbers'
          : t('OnlyAlphanumeric.texto') ||
            'Only alphanumeric characters allowed';
        this.matSnackBar.open(msg, '', { duration: 4000 });
        valid = false;
      }
    }

    if (this.file) {
      const maxBytes = 10 * 1024 * 1024;
      if (this.file.size > maxBytes) {
        const msg = t('FileTooLarge.texto') || 'File must be <= 10MB';
        this.matSnackBar.open(msg, '', { duration: 4000 });
        valid = false;
      }
    }
    return valid;
  }

  // Remove selected file
  deleteFile(): void {
    this.file = null as any;
    this.showfile = false;
    const fileInput = document.getElementById(
      'myfile',
    ) as HTMLInputElement | null;
    if (fileInput) fileInput.value = '';
    console.log('File removed');
  }

  // Optional stubs to avoid missing function errors if invoked
  mostrarError(error: any): void {
    // Reset previous Stripe error info
    this.stripeErrorCode = null;
    this.stripeErrorMessage = null;

    // Prefer explicit Stripe decline_code and seller_message when present
    const declineCode =
      error?.error?.decline_code || error?.decline_code || null;
    const sellerMessage =
      error?.error?.seller_message || error?.seller_message || null;
    const errorMessage = error?.error?.message || error?.message || null;

    // Always log full raw API error for diagnostics (do not show raw to users)
    console.error('[Stripe API Error]', error);

    if (declineCode) {
      // store the raw code and a translated message for the UI
      this.stripeErrorCode = String(declineCode);
      this.stripeErrorMessage = this.getStripeDeclineMessage(
        this.stripeErrorCode,
        errorMessage,
      );

      // For live_mode_test_card, only show the friendly translated message, not the raw code
      if (this.stripeErrorCode === 'live_mode_test_card') {
        this.stripeErrorCode = null;
      }
    } else if (sellerMessage) {
      // show seller message when decline code isn't available
      this.stripeErrorMessage = String(sellerMessage);
    } else if (error?.error?.Menssage) {
      // legacy backend message field (kept for compatibility)
      this.stripeErrorMessage = error.error.Menssage;
    } else if (errorMessage) {
      this.stripeErrorMessage = errorMessage;
    }

    // Trigger change detection so the UI updates immediately
    try {
      this.cdr.detectChanges();
    } catch (e) {
      // ignore
    }
  }

  /**
   * Map a Stripe decline code to a translated message key with the .texto suffix.
   * Falls back to the raw code if no translation exists.
   */
  getStripeDeclineMessage(code: string, fallbackMessage?: string): string {
    if (!code) return fallbackMessage || '';

    // Only translate if the decline code is exactly live_mode_test_card
    if (code === 'live_mode_test_card') {
      const key = `${code}.texto`;
      const translated = this.translate.instant(key);
      if (translated && translated !== key) {
        return translated;
      }
    }

    // For any other code, use the fallback message or the code itself
    return fallbackMessage || code;
  }

  checkIfSendEmail(): void {
    console.log('checkIfSendEmail called');
  }

  payOrder(): void {
    console.log('payOrder called');
  }

  checkAccountStripe() {
    this.serviceCenterService
      .showServiceCenterId(localStorage.getItem('scid') ?? '')
      .subscribe(
        (r: any) => {
          this.valueStripeId = r.settingStripeId;
          // Try to pick a publishable key from the service-center response.
          // The backend may return different field names depending on version.
          const publishable =
            r.stripePublishableKey ||
            r.publishableKey ||
            r.stripePublishable ||
            r.publishable ||
            null;
          if (publishable) {
            localStorage.setItem('stripePublishableKey', String(publishable));
          } else if (r.settingStripeId) {
            // store the setting id so other flows can fetch the key if needed
            localStorage.setItem('settingStripeId', String(r.settingStripeId));
          }
        },
        (e: any) => {
          this.mostrarError(e);
        },
      );
  }

  // Legacy required logic restored per user request
  _mobilePaymentService!: PaymentService; // assigned in constructor
  CrearTarjeta(data: any, token: any) {
    let handlesTaxWithholdings: boolean = this.getHandlesTaxWithholding();
    if (
      (this.IVA == 0 || this.IVA == null) &&
      (this.ISLR == 0 || this.ISLR == null)
    ) {
      handlesTaxWithholdings = false;
    }
    // Ensure we have a token id string
    const tokenId = typeof token === 'string' ? token : (token?.id ?? null);
    console.log('[PaymentComponent] CrearTarjeta called with token param:', {
      token,
      tokenId,
    });

    if (!tokenId) {
      console.error(
        '[PaymentComponent] CrearTarjeta: missing token id, aborting',
      );
      this.mostrarSpinner = false;
      this.process = true;
      this.matSnackBar.open(
        this.translate.instant('ErrorCreatingToken.texto'),
        '',
        {
          duration: 3000,
        },
      );
      return;
    }

    const payload = {
      serviceCenterId: localStorage.getItem('scid'),
      typeOfOriginPayment: 1,
      originId: data.originId,
      value: data.value,
      paymentOrdersId: this.paymentOrderid,
      ivaAmount: this.IVA,
      islrAmount: this.ISLR,
      handlesTaxWithholdings: handlesTaxWithholdings,
      accountCustomerId: localStorage.getItem('accountid'),
      cardToken: tokenId,
      paymentExchangeRate: this.getPaymentExchangeRate(),
    };

    console.log(
      '[PaymentComponent] calling PaymentIntentPaymentOrders with payload:',
      payload,
    );

    this.paymentOrdersService.PaymentIntentPaymentOrders(payload).subscribe(
      (x) => {
        console.log(
          '[PaymentComponent] PaymentIntentPaymentOrders success response:',
          x,
        );
        setTimeout(() => {
          this.mostrarSpinner = false;
        }, 1000);
        let obj = {
          correctProcess: true,
        };
        // Persist account currency only if valid
        try {
          if (this.isValidCurrencyId(this.auxcurrency)) {
            localStorage.setItem('accountcurrency', String(this.auxcurrency));
          } else {
            console.warn(
              '[PaymentComponent] not persisting invalid auxcurrency:',
              this.auxcurrency,
            );
          }
        } catch (e) {
          console.warn(
            '[PaymentComponent] error persisting accountcurrency',
            e,
          );
        }
        this.checkIfSendEmail();
        this.paymentOrder = {
          ...(this.paymentOrder || {}),
          paymentOrderStatus: 4,
        };
        this.openSuccessDialog();
        if (this.dialogRef && typeof this.dialogRef.close === 'function') {
          this.dialogRef.close(obj);
        }
      },
      (e) => {
        console.error(
          '[PaymentComponent] PaymentIntentPaymentOrders error:',
          e,
        );
        this.process = true;
        let fullpayload = {
          ...payload,
          TypeOfLog: 'Order payment',
          TypeOfPayment: this.method,
        };
        let ErrorDataStripe = {
          message: JSON.stringify(e.error?.Menssage || e.message || ''),
          createdAt: new Date().toISOString(),
          createdBy: localStorage.getItem('uid'),
          eventLogTypes: 1,
          classification: 0,
          serializedAdditionalInformation: this.method,
          metadata: fullpayload,
        };
        this._mobilePaymentService.EvenLog(ErrorDataStripe).subscribe(() => {
          setTimeout(() => {
            this.mostrarSpinner = false;
          }, 1000);
          this.mostrarError(e);
        });
      },
    );
  }

  /**
   * Re-checks the service center's active status right before charging the
   * customer (it may have been deactivated after the page was loaded).
   * Shows a snackbar and returns false when it's inactive.
   */
  private checkServiceCenterActive(): Promise<boolean> {
    const scid = localStorage.getItem('scid') ?? '';
    return new Promise((resolve) => {
      this.serviceCenterService.showServiceCenterId(scid).subscribe({
        next: (r: any) => {
          const sc = r?.response?.serviceCenter ?? r;
          const restrictions = safeParseJson(sc?.restrictions ?? null);
          if (isServiceCenterInactive(restrictions)) {
            this.matSnackBar.open(SERVICE_UNAVAILABLE_MESSAGE, '', {
              duration: 5000,
            });
            resolve(false);
            return;
          }
          resolve(true);
        },
        error: (e: any) => {
          console.warn(
            '[PaymentComponent] checkServiceCenterActive failed, allowing payment to continue',
            e,
          );
          resolve(true);
        },
      });
    });
  }

  public async savePay(): Promise<void> {
    // Never submit while a currency switch is still resolving, or when the selected
    // currency has no exchange rate: the amount on screen would not be the real one.
    if (this.currencyChangeInFlight || !this.hasUsableRate()) {
      this.matSnackBar.open(
        this.translate.instant('ConversionError.texto'),
        '',
        {
          duration: 4000,
          verticalPosition: 'bottom',
          panelClass: ['text-danger'],
        },
      );
      this.process = true;
      return;
    }
    const isActive = await this.checkServiceCenterActive();
    if (!isActive) {
      return;
    }
    this.process = false;
    switch (this.method) {
      case 'credit':
        this.PayWithCreditCard();
        break;
      case 'bank':
        this.PayByTransfer();
        break;
      case 'cash':
        this.PayByCash();
        break;
      case 'paypal':
        this.PayWithPaypal();
        break;
      case 'pagomovil':
        this.PayWithMobile();
        break;
      case 'customsvg':
        this.createMercantilTransaction();
        break;
      default:
        this.dialogRef.close(null);
        break;
    }
  }

  // Debug-friendly click handler: log the element at click coordinates and then proceed
  onPayClick(event: MouseEvent) {
    try {
      const x = event.clientX;
      const y = event.clientY;
      const el = document.elementFromPoint(x, y) as HTMLElement | null;
      console.log('[PaymentComponent] onPayClick elementFromPoint', {
        x,
        y,
        el,
      });
    } catch (e) {
      console.warn('[PaymentComponent] onPayClick elementFromPoint error', e);
    }
    // call the existing savePay flow
    this.savePay();
  }

  ValidateTaxBefore() {
    if (this.inputHabilitadoIva || this.inputHabilitadoIslr) {
      if (this.inputHabilitadoIva) {
        if (this.IVA == null) {
          this.matSnackBar.open(
            this.translate.instant('IvaIsMandatory.texto'),
            '',
            {
              duration: 3000,
            },
          );
          return true;
        }
      }
      if (this.inputHabilitadoIslr) {
        if (this.ISLR == null) {
          this.matSnackBar.open(
            this.translate.instant('IslrIsMandatory.texto'),
            '',
            {
              duration: 3000,
            },
          );
          return true;
        }
      }
    }

    let ivaWithOutComma = null;
    if (this.IVA != null) {
      ivaWithOutComma = this.IVA.replace(/,/g, '.');
    }

    let islrWithOutComma = null;
    if (this.ISLR != null) {
      islrWithOutComma = this.ISLR.replace(/,/g, '.');
    }

    let auxIva = ivaWithOutComma == null ? 0 : parseFloat(ivaWithOutComma);
    let auxIslr = islrWithOutComma == null ? 0 : parseFloat(islrWithOutComma);
    let totalOrden = 0;
    const baseTotal = this.getBaseTotal();
    if (this.tasa == 0) {
      totalOrden = baseTotal;
      if (this.igtfFlag) {
        totalOrden = baseTotal + baseTotal * this.igtfTax;
      }
    } else {
      totalOrden = baseTotal * this.tasa;
    }
    if (this.inputHabilitadoIva || this.inputHabilitadoIslr) {
      const totalTax = auxIva + auxIslr;
      const taxPercentage = (totalTax / totalOrden) * 100;
      // debugger
      if (taxPercentage > 40) {
        this.matSnackBar.open(
          this.translate.instant('TheAddShouldNotBeMoreThan40.texto'),
          '',
          {
            duration: 3000,
          },
        );
        return true;
      }
    }
    return false;
  }

  checkIfApplyTax() {
    if (this.handlesTaxWithholdings && this.specialTaxpayer) {
      if (this.inputHabilitadoIva || this.inputHabilitadoIslr) {
        if (this.ValidateTaxBefore()) {
          return true;
        }
      }
    }
    return false;
  }
  getIvaPlusIslr() {
    let iva = this.IVA == null ? 0 : parseFloat(this.IVA);
    let islr = this.ISLR == null ? 0 : parseFloat(this.ISLR);

    return iva + islr;
  }

  /**
   * Order total in the base (foreign) currency. The backend already sends
   * `amountInForeignCurrency` as the order total (quantity included), so it
   * must not be multiplied by `quantity` again.
   */
  getBaseTotal(): number {
    return this.paymentOrder?.amountInForeignCurrency ?? 0;
  }

  /** Order total in the account currency: applies `tasa` when loaded, rounded to 2 decimals. */
  getConvertedTotal(): number {
    const baseTotal = this.getBaseTotal();
    return this.tasa ? parseFloat((baseTotal * this.tasa).toFixed(2)) : baseTotal;
  }

  /**
   * Exchange rate sent to the backend as `PaymentExchangeRate`: the `value`
   * returned by /api/v1/exchange-rate, so every payment records the rate it
   * was made with. Falls back to `tasa` and finally to 1 if no rate was loaded.
   */
  private getPaymentExchangeRate(): number {
    for (const candidate of [this.exchangeRateValue, this.tasa]) {
      const rate = Number(candidate);
      if (Number.isFinite(rate) && rate > 0) return rate;
    }
    return 1;
  }

  /** Stores a valid rate from an /api/v1/exchange-rate response. */
  private storeExchangeRateValue(value: any) {
    const rate = Number(value);
    if (value !== null && value !== undefined && Number.isFinite(rate) && rate > 0) {
      this.exchangeRateValue = rate;
    }
  }

  /**
   * USD payments carry no conversion (`tasa` = 0), so the rate is not fetched by
   * the currency flow. Load the local (non-USD) currency rate so USD payments
   * such as Stripe also send the real `PaymentExchangeRate`.
   */
  private loadLocalExchangeRate() {
    if (!Array.isArray(this.currencySelect) || !this.currencySelect.length) {
      return;
    }
    const local =
      this.currencySelect.find((c: any) => c.isoCode === 'VES') ||
      this.currencySelect.find((c: any) => c.isoCode && c.isoCode !== 'USD');
    const currencyId = local?.id || local?.currencyId;
    if (!currencyId || !this.isValidCurrencyId(currencyId)) return;
    const scid: any = localStorage.getItem('scid');
    this.readUseFirstDayRate().then((flag) => {
      const orderFirstDayRaw = this.paymentOrder?.firstDayRate;
      const orderFlag =
        orderFirstDayRaw === true || String(orderFirstDayRaw) === 'true';
      this.currencyService
        .getTasa(scid, currencyId, !!flag && orderFlag)
        .subscribe({
          next: (datac: any) => {
            // A non-USD currency selected meanwhile owns the rate now.
            if (this.selectedCurrency !== 'USD') return;
            this.storeExchangeRateValue(datac?.value);
          },
          error: (err: any) =>
            console.warn(
              '[PaymentComponent] loadLocalExchangeRate failed',
              err,
            ),
        });
    });
  }

  /**
   * A non-USD currency can only be displayed and paid once a positive exchange
   * rate is loaded. USD needs no conversion, so it is always usable.
   */
  hasUsableRate(): boolean {
    return this.selectedCurrency === 'USD' || (!!this.tasa && this.tasa > 0);
  }

  /** True when the response of an exchange-rate/currency request is no longer the selected one. */
  private isStaleCurrencyResponse(seq: number): boolean {
    if (seq === this.currencyChangeSeq) return false;
    console.warn('[PaymentComponent] discarding stale currency response', {
      responseSeq: seq,
      currentSeq: this.currencyChangeSeq,
    });
    return true;
  }

  /** Leaves the component in a state where the amount is unknown instead of wrong. */
  private markRateUnavailable() {
    const needsRate = this.selectedCurrency !== 'USD';
    this.tasa = 0;
    if (needsRate) {
      // Fallback for when the order is not loaded yet (updateDisplayPrices bails out).
      this.rateUnavailable = true;
      this.displayUnitPrice = null;
      this.displayTotal = null;
    }
    this.updateDisplayPrices();
    this.currencyChangeInFlight = false;
    // USD needs no conversion, so a failed rate request is not worth alerting about.
    if (needsRate) {
      this.matSnackBar.open(
        this.translate.instant('ExchangeRateUnavailable.texto'),
        '',
        {
          duration: 5000,
          verticalPosition: 'bottom',
          panelClass: ['text-danger'],
        },
      );
    }
    try {
      this.cdr.detectChanges();
    } catch {}
  }

  private getTasaWithoutFirstDay(
    scid: any,
    currencyL: any,
    seq: number = this.currencyChangeSeq,
  ) {
    this.currencyService.getTasa(scid, currencyL, false).subscribe({
      next: (datac: any) => {
        if (this.isStaleCurrencyResponse(seq)) return;
        // Guard against null/empty responses (e.g. 204 No Content) to avoid TypeError
        const incomingValue = datac?.value;
        if (
          incomingValue !== null &&
          incomingValue !== undefined &&
          !isNaN(Number(incomingValue))
        ) {
          this.tasa = Number(incomingValue);
          this.storeExchangeRateValue(incomingValue);
        } else {
          console.warn(
            '[PaymentComponent] getTasaWithoutFirstDay: missing/invalid value in response -> using 0',
            datac,
          );
          this.tasa = 0; // safe default
        }
        this.currencyChangeInFlight = false;
        setTimeout(() => {
          this.mostrarSpinner = false;
        }, 1000);
        // Recompute display prices after tasa is fetched (affects VES/local currencies)
        this.updateDisplayPrices();
      },
      error: (err: any) => {
        if (this.isStaleCurrencyResponse(seq)) return;
        setTimeout(() => {
          this.mostrarSpinner = false;
        }, 1000);
        // Drop the previous currency's rate so no stale conversion is shown or paid.
        this.markRateUnavailable();
        this.mostrarError(err);
      },
    });
  }

  private getTasa(
    scid: any,
    currencyL: any,
    firstDayRate?: boolean,
    seq: number = this.currencyChangeSeq,
  ) {
    const fd =
      typeof firstDayRate === 'boolean' ? firstDayRate : this.useFirstDayRate;
    this.currencyService.getTasa(scid, currencyL, fd).subscribe({
      next: (datac: any) => {
        if (this.isStaleCurrencyResponse(seq)) return;
        const incomingValue = datac?.value;
        if (
          incomingValue !== null &&
          incomingValue !== undefined &&
          !isNaN(Number(incomingValue))
        ) {
          this.tasa = Number(incomingValue);
          this.storeExchangeRateValue(incomingValue);
        } else {
          console.warn(
            '[PaymentComponent] getTasa: missing/invalid value in response -> using 0',
            datac,
          );
          this.tasa = 0;
        }
        this.currencyChangeInFlight = false;
        setTimeout(() => {
          this.mostrarSpinner = false;
        }, 1000);

        // Skip display update if USD since tasa is 0 and base price already set
        if (this.selectedCurrency !== 'USD') {
          this.updateDisplayPrices();
        }
      },
      error: (err: any) => {
        if (this.isStaleCurrencyResponse(seq)) return;
        setTimeout(() => {
          this.mostrarSpinner = false;
        }, 1000);
        // Drop the previous currency's rate so no stale conversion is shown or paid.
        this.markRateUnavailable();
        this.mostrarError(err);
      },
    });
  }

  changeCurrency(userInitiated: boolean = false) {
    // Claim this change: any response belonging to an older switch is discarded.
    const seq = ++this.currencyChangeSeq;
    this.currencyChangeInFlight = true;
    // Safety net: a request that never settles must not lock the UI forever.
    setTimeout(() => {
      if (seq === this.currencyChangeSeq && this.currencyChangeInFlight) {
        console.warn(
          '[PaymentComponent] changeCurrency timed out, invalidating rate',
        );
        this.mostrarSpinner = false;
        this.markRateUnavailable();
      }
    }, 15000);
    // Start spinner for UX feedback
    this.mostrarSpinner = true;
    const iso = this.selectedCurrency; // 'USD' | 'VES' | other
    const scid: any = localStorage.getItem('scid');

    // Map iso code to currency id using currencySelect list (if loaded)
    let currencyId: string | null = null;
    if (Array.isArray(this.currencySelect) && this.currencySelect.length) {
      const found = this.currencySelect.find(
        (c: any) => c.isoCode === iso || c.code === iso || c.id === iso,
      );
      currencyId = found?.id || found?.currencyId || null;
    }
    // Fallback: if previously stored currency id corresponds to same iso, keep it
    if (!currencyId && this.accountCurrency?.isoCode === iso) {
      currencyId = this.accountCurrency.id;
    }

    // Optimistically set accountCurrency iso so template updates immediately
    if (iso && this.accountCurrency) {
      this.accountCurrency = { ...this.accountCurrency, isoCode: iso };
    }

    // Reset tasa for base currencies (USD & VES). Business rule: USD and VES should not carry previous tasa multiplication.
    if (iso === 'USD' || iso === 'VES') {
      this.tasa = 0;
    }

    // If the user changed the selector explicitly, clear any previously selected method
    // so they must re-select a payment method appropriate for the new currency.
    if (userInitiated) {
      this.method = '';
    } else {
      // Preserve existing selected method unless user explicitly changes it elsewhere
      if (!this.method) {
        const defMethod = localStorage.getItem('defaultMethod');
        if (defMethod) this.method = defMethod;
      }
    }

    // Skip redundant display update if USD and not user-initiated (initialization sequence)
    // as base price was already set during order fetch
    if (!(this.selectedCurrency === 'USD' && !userInitiated)) {
      this.updateDisplayPrices(); // Update display prices based on selected currency and tasa
    }

    this.showAccountPayment(); // Refresh bank accounts for the new currency
    this.loadDataBank(); // Refresh mobile payment banks for the new currency

    // If no currency id resolved (maybe list not loaded yet), just finish spinner
    if (!currencyId) {
      setTimeout(() => {
        if (seq !== this.currencyChangeSeq) return;
        this.currencyChangeInFlight = false;
        if (userInitiated) {
          this.mostrarSpinner = false;
        }
        try {
          this.cdr.detectChanges();
        } catch {}
      }, 150);
      return;
    }

    this.currency = currencyId;

    // Fetch full currency data to ensure correct id & tasa logic for non-USD/VES
    if (!this.isValidCurrencyId(currencyId)) {
      console.warn(
        '[PaymentComponent] changeCurrency: invalid currencyId, skipping getCurrency',
        currencyId,
      );
      this.currencyChangeInFlight = false;
      this.mostrarSpinner = false;
      return;
    }
    this.currencyService.getCurrency(currencyId).subscribe(
      (data: any) => {
        // Defer to next tick to avoid NG0100
        setTimeout(() => {
          if (this.isStaleCurrencyResponse(seq)) return;
          this.accountCurrency = data || this.accountCurrency;
          // Ensure iso consistency if backend returns different iso
          if (data?.isoCode) {
            this.selectedCurrency = data.isoCode;
          }
          // Preserve or auto-select default method if none chosen
          if (!this.method) {
            this.method = '';
          }
          // Business rule: VES => tasa = 0, USD => tasa = 0, others load tasa
          if (this.accountCurrency.isoCode === 'USD') {
            this.tasa = 0;
            this.currencyChangeInFlight = false;
            this.updateDisplayPrices();
            // Keep the real rate for PaymentExchangeRate even without conversion.
            this.loadLocalExchangeRate();
          } else if (this.accountCurrency.isoCode === 'VES') {
            // For VES we need a tasa to convert from foreign/base price; fetch if not already loaded
            if (!this.tasa || this.tasa === 0) {
              // ensure we read the most up-to-date flag before calling
              this.readUseFirstDayRate().then((flag) => {
                const orderFirstDayRaw = this.paymentOrder?.firstDayRate;
                const orderFlag = !!(
                  this.paymentOrder &&
                  (orderFirstDayRaw === true ||
                    String(orderFirstDayRaw) === 'true')
                );
                const useFlag = !!flag && orderFlag;
                console.log('[PaymentComponent] readUseFirstDayRate ->', {
                  localStorageFlag: flag,
                  paymentOrderFirstDayRate: orderFirstDayRaw,
                  orderFlag,
                  useFlag,
                });
                if (this.isStaleCurrencyResponse(seq)) return;
                useFlag
                  ? this.getTasa(scid, currencyId, true, seq)
                  : this.getTasaWithoutFirstDay(scid, currencyId, seq);
              });
            } else {
              this.currencyChangeInFlight = false;
            }
            // We'll update prices again after tasa observable completes; for now compute with current tasa
            this.updateDisplayPrices();
          } else {
            // non-USD/VES currencies
            this.readUseFirstDayRate().then((flag) => {
              const orderFlag = !!(
                this.paymentOrder && this.paymentOrder.firstDayRate === true
              );
              const useFlag = !!flag && orderFlag;
              if (this.isStaleCurrencyResponse(seq)) return;
              useFlag
                ? this.getTasa(scid, currencyId, true, seq)
                : this.getTasaWithoutFirstDay(scid, currencyId, seq);
            });
            // Prices will be updated when tasa loads; compute interim without tasa
            this.updateDisplayPrices();
          }
          // Recompute displayed amounts after possible tasa change
          if (this.accountCurrency.isoCode === 'USD' && this.igtfFlag) {
            this.matSnackBar.open(this.translate.instant('IgtfLaw.texto'), '', {
              duration: 3000,
            });
          }
          if (userInitiated) {
            this.mostrarSpinner = false;
          }
          try {
            this.cdr.detectChanges();
          } catch {}
        }, 0);
      },
      (error) => {
        console.warn('[PaymentComponent] changeCurrency fetch failed', error);
        if (this.isStaleCurrencyResponse(seq)) return;
        this.mostrarSpinner = false;
        // The currency was already switched optimistically, so the previous rate no
        // longer belongs to it: invalidate it instead of pricing with a stale tasa.
        this.markRateUnavailable();
      },
    );
  }

  isMobilePaymentValid(): boolean {
    // Only validate when pagomovil method is selected
    if (this.method !== 'pagomovil') return true;

    // Reset previous errors & summary
    this.mobileValidationErrors = {
      phoneNumber: null,
      prefixPhoneNumber: null,
      bankSelected: null,
      dni: null,
      Otp: null,
    };
    this.mobileValidationSummary = null;
    let valid = true;
    const t = (k: string) => this.translate.instant(k);
    const orderKeys: { key: string; label: string }[] = [
      { key: 'bankSelected', label: t('SelectBank.texto') },
      { key: 'phoneNumber', label: t('PhoneNumber.texto') },
      {
        key: 'dni',
        label: t('DocumentNumber.texto') || t('DocumentFrom.texto'),
      },
      { key: 'Otp', label: t('Otp.texto') },
    ];
    const missingLabels: string[] = [];
    // Evaluate in order, marking valid false
    orderKeys.forEach((item) => {
      if (!(this as any)[item.key]) {
        missingLabels.push(item.label);
        valid = false;
      }
    });
    // prefix phoneNumber part includes prefixPhoneNumber; treat absence of prefix as phone missing
    if (
      !this.prefixPhoneNumber &&
      !missingLabels.includes(t('PhoneNumber.texto'))
    ) {
      missingLabels.push(t('PhoneNumber.texto'));
      valid = false;
    }
    if (missingLabels.length) {
      // Single snackbar: prefijo + lista de campos faltantes
      const prefixMsg =
        this.translate.currentLang === 'es'
          ? 'Complete los siguientes campos:'
          : 'Please complete the following fields:';
      this.mobileValidationSummary = `${prefixMsg} ${missingLabels.join(', ')}`;
      this.matSnackBar.open(this.mobileValidationSummary || '', '', {
        duration: 4000,
      });
      return false; // Evitar segundo snackbar de formato cuando faltan campos
    }

    // Format/length checks (only if present)
    // phoneNumber (input field only) must be digits and max 7 characters
    const rawPhone = String(this.phoneNumber || '').replace(/\s+/g, '');
    const digitsOnly = rawPhone.replace(/\D/g, '');
    if (rawPhone && digitsOnly.length !== rawPhone.length) {
      this.mobileValidationErrors.phoneNumber = `${t(
        'PhoneNumber.texto',
      )} - ${t('OnlyAdmitsNumbers.texto')}`;
      this.matSnackBar.open(this.mobileValidationErrors.phoneNumber || '', '', {
        duration: 4000,
      });
      valid = false;
    }
    if (digitsOnly && digitsOnly.length > 0 && digitsOnly.length < 7) {
      // Specific message for fewer than required digits
      this.mobileValidationErrors.phoneNumber = t(
        'PhoneNumberMustHave7Digits.texto',
      );
      this.matSnackBar.open(this.mobileValidationErrors.phoneNumber || '', '', {
        duration: 4000,
      });
      valid = false;
    }
    if (digitsOnly && digitsOnly.length > 7) {
      this.mobileValidationErrors.phoneNumber = `${t(
        'PhoneNumber.texto',
      )} (max 7)`;
      this.matSnackBar.open(this.mobileValidationErrors.phoneNumber || '', '', {
        duration: 4000,
      });
      valid = false;
    }

    if (this.dni && String(this.dni).length > 16) {
      const base = this.mobileValidationErrors.dni || t('DocumentNumber.texto');
      this.mobileValidationErrors.dni = base + ' (max 16)';
      this.matSnackBar.open(this.mobileValidationErrors.dni || '', '', {
        duration: 4000,
      });
      valid = false;
    }

    if (this.Otp && String(this.Otp).length > 8) {
      this.mobileValidationErrors.Otp = `${t('Otp.texto')} (max 8)`;
      this.matSnackBar.open(this.mobileValidationErrors.Otp || '', '', {
        duration: 4000,
      });
      valid = false;
    }

    return valid;
  }
  showAccountPayment() {
    // Resolve currency ID using the same logic as changeCurrency
    const iso = this.selectedCurrency;
    let currencyId: string | null = null;

    // Try to get currency ID from currencySelect array
    if (Array.isArray(this.currencySelect) && this.currencySelect.length) {
      const found = this.currencySelect.find(
        (c: any) => c.isoCode === iso || c.code === iso || c.id === iso,
      );
      currencyId = found?.id || found?.currencyId || null;
    }
    // Fallback: if previously stored currency id corresponds to same iso, keep it
    if (!currencyId && this.accountCurrency?.isoCode === iso) {
      currencyId = this.accountCurrency.id;
    }
    // Fallback: use this.currency if already set
    if (!currencyId && this.currency) {
      currencyId = this.currency;
    }

    if (!currencyId) {
      console.warn(
        '[PaymentComponent] showAccountPayment: no valid currencyId resolved',
      );
      return;
    }

    this._bankAccountsService.filterBankAccounts(currencyId).subscribe(
      (data: any) => {
        setTimeout(() => {
          // Handle both 'list' (new API) and 'result' (old API) response formats
          const items = data?.list || data?.result || [];
          if (items && items.length > 0) {
            this.dataBank = items.map((item: any) => {
              const accountTypeLabel = this.getAccountTypeLabel(
                item.accountType,
              );
              const accountCode = item.accountCode || '';

              // Display name for dropdown: Bank Name - Account Type (except for Zelle type 4)
              let displayName = '';
              if (item.accountType === 4) {
                displayName = item.bank?.bankName || '';
              } else {
                displayName = `${
                  item.bank?.bankName || ''
                } - ${accountTypeLabel}`;
              }

              // Build account data string: Account Type: Account Code + holder info
              let accountDataParts: string[] = [];
              // First line: Account Type: Account Code
              if (accountCode) {
                accountDataParts.push(`${accountTypeLabel}: ${accountCode}`);
              } else {
                accountDataParts.push(accountTypeLabel);
              }
              if (item.accountHolders?.name) {
                accountDataParts.push(item.accountHolders.name);
              }
              if (item.accountHolders?.identificationCode) {
                accountDataParts.push(item.accountHolders.identificationCode);
              }
              const accountData =
                accountDataParts.join('\n') || item.email || '';

              return {
                ...item,
                bankName: item.bank?.bankName || '',
                name: displayName,
                accountData: accountData,
              };
            });
            this.bankName = this.dataBank;
          } else {
            this.dataBank = [];
            this.bankName = [];
          }

          try {
            this.cdr.detectChanges();
          } catch (e) {
            /* ignore */
          }
        }, 0);
      },
      (err: any) => {
        console.error('[PaymentComponent] showAccountPayment error:', err);
        this.dataBank = [];
        this.bankName = [];
      },
    );
  }

  private loadDataBank() {
    this.typeOfBank = localStorage.getItem('bankNumber');
    if (this.typeOfBank != '') {
      this._mobilePaymentService
        .GetBanks(this.typeOfBank, localStorage.getItem('scid') ?? '')
        .subscribe(
          (response) => {
            this.listOfBanks = response.banks;
          },
          (error) => {
            console.log('Error al listar los bancos aceptados', error);
          },
        );
    }
  }
  getAccountTypeLabel(accountType: number): string {
    switch (accountType) {
      case 0:
        return this.translate.instant('CurrentAccount.texto');
      case 1:
        return this.translate.instant('SavingsAccount.texto');
      case 2:
        return this.translate.instant('ForeignCurrencyAccount.texto');
      case 3:
        return this.translate.instant('MobilePaymentAccount.texto');
      case 4:
        return this.translate.instant('ZelleAccount.texto');
      default:
        return this.translate.instant('NoAccountType.texto');
    }
  }
  getCurrency() {
    this.mostrarSpinner = true;
    const currencyL = localStorage.getItem('accountcurrency');
    const scid: any = localStorage.getItem('scid');

    // Load available currencies for selection
    this.currencyService.getCurrencySelect().subscribe(
      (data: any) => {
        this.currencySelect = data;
        // If there's no explicit account currency set, pick a sensible default
        if (
          !currencyL &&
          Array.isArray(this.currencySelect) &&
          this.currencySelect.length
        ) {
          // prefer USD if present
          const prefer =
            this.currencySelect.find((c: any) => c.isoCode === 'USD') ||
            this.currencySelect[0];
          this.selectedCurrency = prefer?.isoCode ?? this.selectedCurrency;
          this.currency = prefer?.id ?? this.currency;
        }
        this.loadLocalExchangeRate();
      },
      (error) => {
        console.warn('[PaymentComponent] getCurrencySelect failed', error);
        this.mostrarError(error);
      },
    );

    // If the account has a configured display currency id, load it and sync UI
    if (currencyL) {
      if (!this.isValidCurrencyId(currencyL)) {
        console.warn(
          '[PaymentComponent] getCurrency: invalid stored accountcurrency, skipping getCurrency',
          currencyL,
        );
        return;
      }
      this.currencyService.getCurrency(currencyL).subscribe(
        (data: any) => {
          // Defer UI-updating assignments to avoid ExpressionChangedAfterItHasBeenCheckedError
          setTimeout(() => {
            this.accountCurrency = data;
            this.currentCurrency = this.accountCurrency.id;
            // sync selectedCurrency to the account's iso code so the UI shows the right option
            if (this.accountCurrency?.isoCode) {
              this.selectedCurrency = this.accountCurrency.isoCode;
            }
            // keep currency id for internal calls
            this.currency = this.accountCurrency.id;

            // If currency is USD we keep tasa = 0. For VES and any other non-USD
            // currency we must fetch the tasa so amounts are displayed multiplied.
            if (this.accountCurrency.isoCode === 'USD') {
              this.tasa = 0;
            } else {
              // Wait for the persisted flag and then call the appropriate tasa fetcher
              this.readUseFirstDayRate().then((flag) => {
                const orderFlag = !!(
                  this.paymentOrder && this.paymentOrder.firstDayRate === true
                );
                const useFlag = !!flag && orderFlag;
                useFlag
                  ? this.getTasa(scid, currencyL, true)
                  : this.getTasaWithoutFirstDay(scid, currencyL);
              });
            }

            // Update displayed prices now (will be recalculated again when tasa arrives)
            this.updateDisplayPrices();
          }, 0);
        },
        (error) => {
          console.warn(
            '[PaymentComponent] getCurrency (account) failed',
            error,
          );
        },
      );
    }
  }
  PayWithMobile() {
    if (this.checkIfApplyTax()) {
      this.process = true;
      return;
    }
    // C2P is charged in the local currency, so it requires a valid exchange rate.
    if (!this.hasUsableRate()) {
      this.matSnackBar.open(
        this.translate.instant('ConversionError.texto'),
        '',
        {
          duration: 4000,
          verticalPosition: 'bottom',
          panelClass: ['text-danger'],
        },
      );
      this.process = true;
      return;
    }

    // Validate required fields and show inline errors if any
    if (!this.isMobilePaymentValid()) {
      this.process = true;
      return;
    }

    const EXPREG_ONLYNUMBERSPHONE = /^(\d{7,7})$/;
    const EXPREG_ONLYNUMBERSDNI = /^(\d{7,20})$/;

    if (this.Validate(EXPREG_ONLYNUMBERSPHONE, this.phoneNumber)) {
      this.matSnackBar.open(
        this.translate.instant('TheField.texto') +
          ' ' +
          this.translate.instant('PhoneNumber.texto') +
          ' ' +
          this.translate.instant('OnlyAdmitsNumbers.texto'),
        '',
        {
          duration: 8000,
        },
      );
      this.process = true;
      return;
    }

    if (this.Validate(EXPREG_ONLYNUMBERSDNI, this.dni)) {
      this.matSnackBar.open(
        this.translate.instant('TheField.texto') +
          ' ' +
          this.translate.instant('DocumentFrom.texto') +
          ' ' +
          this.translate.instant('Identification.texto') +
          ' ' +
          this.translate.instant('OnlyAdmitsNumbers.texto'),
        '',
        {
          duration: 8000,
        },
      );
      this.process = true;
      return;
    }

    this.mostrarSpinner = true;
    let cellPhoneNumber = this.prefixPhoneNumber + this.phoneNumber;
    if (this.typeOfBank == '2') {
      cellPhoneNumber = cellPhoneNumber.substring(2);
    }
    let handlesTaxWithholdings: boolean = this.getHandlesTaxWithholding();
    if (
      (this.IVA == 0 || this.IVA == null) &&
      (this.ISLR == 0 || this.ISLR == null)
    ) {
      handlesTaxWithholdings = false;
    }
    // Order total (amountInForeignCurrency) converted applying tasa if present
    const convertedAmount = this.getConvertedTotal();
    const netValue = convertedAmount - this.getIvaPlusIslr();
    if (!this.paymentOrder) {
      console.warn(
        '[PaymentComponent] PayWithMobile invoked without paymentOrder loaded',
      );
      this.process = true;
      return;
    }
    let data = {
      serviceCenterId: localStorage.getItem('scid'),
      customerAccountId: localStorage.getItem('accountid'),
      dateOfPayment: new Date().toISOString(),
      transactionCurrencyCode: this.accountCurrency.isoCode,
      statusPayment: 0,
      value: netValue,
      originId: this.paymentOrder.serviceRequestId,
      banks: parseInt(this.typeOfBank, 10),
      paymentExchangeRate: this.getPaymentExchangeRate(),
      requestBank: {
        banco_origen: this.bankSelected,
        telf_origen: cellPhoneNumber,
        dni_origen: this.PrefixDni + this.dni,
        monto: netValue,
        otp: this.Otp,
        ivaAmount: this.IVA,
        islrAmount: this.ISLR,
        handlesTaxWithholdings: handlesTaxWithholdings,
      },
    };
    // Using paymentOrder.id instead of data.id (data is now payload)
    this._mobilePaymentService
      .PayOrdersById(this.paymentOrder.id, data)
      .subscribe(
        (response) => {
          this.matSnackBar.open(
            this.translate.instant('Payregister.texto'),
            '',
            {
              duration: 8000,
            },
          );
          let obj = {
            correctProcess: true,
          };
          this.mostrarSpinner = false;
          // Persist account currency only if valid
          try {
            if (this.isValidCurrencyId(this.auxcurrency)) {
              localStorage.setItem('accountcurrency', String(this.auxcurrency));
            } else {
              console.warn(
                '[PaymentComponent] not persisting invalid auxcurrency (mobile):',
                this.auxcurrency,
              );
            }
          } catch (e) {
            console.warn(
              '[PaymentComponent] error persisting accountcurrency (mobile)',
              e,
            );
          }
          this.checkIfSendEmail();
          this.paymentOrder = {
            ...(this.paymentOrder || {}),
            paymentOrderStatus: 4,
          };
          this.openSuccessDialog();
          this.dialogRef.close(obj);
        },
        (error) => {
          this.process = true;
          this.mostrarSpinner = false;

          let fullpayload = {
            id: this.paymentOrder.id,
            serviceCenterId: localStorage.getItem('scid'),
            customerAccountId: localStorage.getItem('accountid'),
            dateOfPayment: new Date().toISOString(),
            transactionCurrencyCode: this.accountCurrency.isoCode,
            statusPayment: 0,
            value: netValue,
            originId: this.paymentOrder.serviceRequestId,
            banks: parseInt(this.typeOfBank, 10),
            requestBank: JSON.stringify(data.requestBank),
            TypeOfLog: 'Order payment',
            TypeOfPayment: this.method,
          };

          let ErrorData = {
            message: error.error.Menssage,
            createdAt: new Date().toISOString(),
            createdBy: localStorage.getItem('uid'),
            eventLogTypes: 1,
            classification: 0,
            serializedAdditionalInformation: this.method,
            metadata: fullpayload,
          };

          // Error mapping logic
          let descripcion = '';
          let code = '';
          let mappedMessage = '';
          try {
            if (error?.error?.Menssage) {
              // Remove escaped quotes and parse JSON if possible
              let msg = error.error.Menssage.replace(/\\u0022/g, '"').replace(
                /\\/g,
                '',
              );
              if (msg.startsWith('{')) {
                const parsed = JSON.parse(msg);
                code = parsed.code;
                descripcion = parsed.descripcion || '';
              } else {
                descripcion = msg;
              }
            } else if (typeof error?.error === 'string') {
              descripcion = error.error;
            }
          } catch (e) {
            descripcion = '';
          }

          // Map error codes/descriptions to user-friendly messages
          switch (code) {
            case '0055':
              mappedMessage = this.translate.instant('MobileCodeInvalid.texto');
              break;
            case '0041':
            case '0091':
              mappedMessage = this.translate.instant('ServiceNotActive.texto');
              break;
            case '0014':
              mappedMessage = this.translate.instant(
                'PhoneNotAffiliated.texto',
              );
              break;
            case '0022':
              mappedMessage = this.translate.instant('IdNotAffiliated.texto');
              break;
            case '9045':
            case '0005':
              mappedMessage = this.translate.instant('TimeExceeded.texto');
              break;
            case '0051':
              mappedMessage = this.translate.instant(
                'InsufficientBalance.texto',
              );
              break;
            case '0012':
              mappedMessage = this.translate.instant(
                'InvalidTransaction.texto',
              );
              break;
            default:
              // Special case for repeated correlative
              if (descripcion && descripcion.includes('Repeated Correlative')) {
                mappedMessage = 'Referencia ya usada';
              } else if (descripcion) {
                mappedMessage = descripcion;
              } else {
                mappedMessage = this.translate.instant(
                  'ErrorGeneratingPaymentContactSupport.texto',
                );
              }
              break;
          }

          // Show mapped message
          this.matSnackBar.open(mappedMessage, '', {
            duration: 5000,
            panelClass: ['text-danger'],
          });

          // Still send to EvenLog for backend tracking
          this._mobilePaymentService.EvenLog(ErrorData).subscribe();
        },
      );
  }

  PayByCash() {
    // Use the selectedCurrency (iso code like 'USD'/'VES') to find the currency id
    this.mostrarSpinner = true;
    const iso = this.selectedCurrency;
    let currencyId = iso;
    if (Array.isArray(this.currencySelect)) {
      const found = this.currencySelect.find(
        (c: any) => c.isoCode === iso || c.code === iso || c.id === iso,
      );
      if (found) currencyId = found.id;
    }
    this.currency = currencyId;
    const scid: any = localStorage.getItem('scid');

    if (!currencyId) {
      // nothing to do
      this.mostrarSpinner = false;
      return;
    }

    if (!this.isValidCurrencyId(currencyId)) {
      console.warn(
        '[PaymentComponent] PayByCash: invalid currencyId, skipping getCurrency',
        currencyId,
      );
      this.mostrarSpinner = false;
      return;
    }
    this.currencyService.getCurrency(currencyId).subscribe(
      (data: any) => {
        this.accountCurrency = data;
        // If returned currency is not USD, load tasa
        // Business rule: if currency is VES we do NOT multiply by tasa.
        if (this.accountCurrency.isoCode === 'VES') {
          this.tasa = 0;
        } else if (this.accountCurrency.isoCode !== 'USD') {
          this.readUseFirstDayRate().then((flag) => {
            const orderFlag = !!(
              this.paymentOrder && this.paymentOrder.firstDayRate === true
            );
            const useFlag = !!flag && orderFlag;
            useFlag
              ? this.getTasa(scid, currencyId, true)
              : this.getTasaWithoutFirstDay(scid, currencyId);
          });
        } else {
          this.tasa = 0;
          if (this.igtfFlag) {
            this.matSnackBar.open(this.translate.instant('IgtfLaw.texto'), '', {
              duration: 3000,
            });
          }
        }
        // Ensure template reflects availability of payment methods tied to currency
        try {
          this.cdr.detectChanges();
        } catch (e) {
          console.warn(
            '[PaymentComponent] detectChanges after changeCurrency failed',
            e,
          );
        }
        setTimeout(() => {
          this.mostrarSpinner = false;
        }, 250);
      },
      (error) => {
        console.warn('[PaymentComponent] changeCurrency failed', error);
        setTimeout(() => {
          this.mostrarSpinner = false;
        }, 250);
      },
    );
  }

  private ValidateReference() {
    const raw: any = this.formPaymenBank?.value?.numberReference ?? '';
    const value = String(raw).trim();
    if (!value) return false;
    // allow only alphanumeric, length between 10 and 15
    const EXPREG = /^[a-zA-Z0-9]{10,15}$/;
    return EXPREG.test(value);
  }

  private ValidateReferenceLength() {
    const raw: any = this.formPaymenBank?.value?.numberReference ?? '';
    const reference = String(raw).trim();
    const len = reference.length;
    return len >= 10 && len <= 15;
  }

  private ValidateBeforePay() {
    // Prefer to show a specific validation message for the reference field
    // (length or invalid characters) before the generic "complete all fields".
    const refCtrl = this.formPaymenBank?.get('numberReference');
    const rawRef = refCtrl?.value ?? '';
    const reference = String(rawRef).trim();

    // If user entered something for reference, surface length/pattern issues first
    if (reference.length > 0) {
      if (reference.length < 10 || reference.length > 15) {
        this.matSnackBar.open(
          this.translate.instant('BankReferenceErrorLength.texto'),
          '',
          { duration: 5000 },
        );
        return true;
      }
      const EXPREG = /^[a-zA-Z0-9]{10,15}$/;
      if (!EXPREG.test(reference)) {
        this.matSnackBar.open(
          this.translate.instant('BankReferenceError.texto'),
          '',
          { duration: 5000 },
        );
        return true;
      }
    }

    // Fallback: if the form is invalid (missing required fields, etc.) show generic message
    if (this.formPaymenBank.invalid) {
      this.matSnackBar.open(
        this.translate.instant('CompleteAllRequiredFields.texto'),
        '',
        {
          duration: 3000,
        },
      );
      this.errorflag = true;
      return true;
    }

    return false;
  }
  formatDateToDDMMYYYY(date: Date): string {
    if (!date) return '';
    // Accept Date instances or ISO/date strings
    const d = typeof date === 'string' ? new Date(date) : date;
    if (Number.isNaN(d.getTime())) return '';
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  }

  fillFormData() {
    //borar en caso de fallo

    if (!this.inputHabilitadoIva) {
      this.IVA = 0;
    }

    if (!this.inputHabilitadoIslr) {
      this.ISLR = 0;
    }

    //end borrar

    let handlesTaxWithholdings: boolean = this.getHandlesTaxWithholding();
    if (
      (this.IVA == 0 || this.IVA == null) &&
      (this.ISLR == 0 || this.ISLR == null)
    ) {
      handlesTaxWithholdings = false;
    }
    //console.log('handlesTaxWithholdings: ', handlesTaxWithholdings);
    const value = this.getConvertedTotal() - this.getIvaPlusIslr();
    this.formData = new FormData();
    this.formData.append('formFile', this.file != null ? this.file : '');
    this.formData.append(
      'CurrentSessionUserId',
      localStorage.getItem('cid') ?? '',
    );
    this.formData.append('OriginId', this.originId);
    this.formData.append('ServiceCenterId', localStorage.getItem('scid') ?? '');
    this.formData.append(
      'CustomerAccountId',
      localStorage.getItem('accountid') ?? '',
    );
    this.formData.append('TypeOfOriginPayment', '1');
    this.formData.append('Value', value.toString());
    this.formData.append('BankName', this.formPaymenBank.value.BankName);
    this.formData.append(
      'ReferenceNumber',
      this.formPaymenBank.value.numberReference,
    );
    // Format date to ISO 8601
    const transferDate = this.formPaymenBank.value.dateComplet;
    let formattedDate = '';
    if (transferDate) {
      const d =
        typeof transferDate === 'string'
          ? new Date(transferDate)
          : transferDate;
      if (!Number.isNaN(d.getTime())) {
        formattedDate = d.toISOString();
      }
    }
    this.formData.append('TransferDate', formattedDate);
    this.formData.append(
      'BillNumber',
      this.formPaymenBank.value.numberReference,
    );
    this.formData.append(
      'AccountHolder',
      this.formPaymenBank.value.accountHolder,
    );
    this.formData.append(
      'TransactionCurrencyCode',
      this.accountCurrency.isoCode,
    );
    this.formData.append('IvaAmount', this.IVA == null ? 0 : this.IVA);
    this.formData.append('IslrAmount', this.ISLR == null ? 0 : this.ISLR);
    this.formData.append(
      'HandlesTaxWithholdings',
      handlesTaxWithholdings.toString(),
    );
    this.formData.append(
      'PaymentExchangeRate',
      this.getPaymentExchangeRate().toString(),
    );
  }
  PayByTransfer() {
    if (this.checkIfApplyTax()) {
      this.process = true;
      return;
    }

    if (this.ValidateBeforePay()) {
      this.process = true;
      return;
    }

    // New transfer form validation (shows inline errors and snackbar)
    if (!this.isTransferValid()) {
      // show snackbar with aggregated messages and list of missing fields (translated)
      const keysWithErrors = Object.keys(this.transferValidationErrors).filter(
        (k) => (this.transferValidationErrors as any)[k],
      );
      const messages: string[] = [];
      for (const k of keysWithErrors) {
        const v = (this.transferValidationErrors as any)[k];
        if (v) messages.push(v);
      }

      // Determine missing/invalid form controls (only bank transfer controls)
      const missingFieldKeys: string[] = [];
      try {
        if (this.formPaymenBank) {
          const controls = this.formPaymenBank.controls;
          if (
            controls['numberReference'] &&
            controls['numberReference'].invalid
          )
            missingFieldKeys.push('numberReference');
          if (controls['BankName'] && controls['BankName'].invalid)
            missingFieldKeys.push('BankName');
          if (controls['accountHolder'] && controls['accountHolder'].invalid)
            missingFieldKeys.push('accountHolder');
          if (controls['dateComplet'] && controls['dateComplet'].invalid)
            missingFieldKeys.push('dateComplet');
        }
      } catch (e) {
        // ignore
      }

      // Map form keys to translation keys for user-friendly labels
      const labelMap: any = {
        numberReference: 'ReferenceNumber.texto',
        BankName: 'ReceivingBankName.texto',
        accountHolder: 'AccountHolder.texto',
        dateComplet: 'TransferDate.texto',
        file: 'AttachPaymentReceipt.texto',
      };

      const missingLabels: string[] = [];
      // Prefer listing all keys that have validation messages (so user sees everything missing/invalid)
      for (const k of keysWithErrors) {
        const labKey = labelMap[k] || null;
        if (labKey) missingLabels.push(this.translate.instant(labKey));
      }

      let message = '';
      if (messages.length > 0) {
        message = Array.from(new Set(messages)).join(', ');
        if (missingLabels.length > 0) {
          message = `${message}. ${this.translate.instant(
            'CompleteAllRequiredFields.texto',
          )}: ${Array.from(new Set(missingLabels)).join(', ')}`;
        }
      } else if (missingLabels.length > 0) {
        message = `${this.translate.instant(
          'CompleteAllRequiredFields.texto',
        )}: ${Array.from(new Set(missingLabels)).join(', ')}`;
      } else {
        message = this.translate.instant('CompleteAllRequiredFields.texto');
      }

      this.matSnackBar.open(message, '', { duration: 6000 });
      this.process = true;
      return;
    }
    this.errorflag = false;
    this.mostrarSpinner = true;
    this.fillFormData();
    this.paymentOrdersService
      .PayOrdersByTransferWithFile(this.paymentOrderid, this.formData)
      .subscribe(
        (x) => {
          setTimeout(() => {
            this.mostrarSpinner = false;
          }, 1000);
          let obj = {
            correctProcess: true,
          };
          this.matSnackBar.open(
            this.translate.instant('PayRegister.texto'),
            '',
            {
              duration: 5000,
            },
          );
          // Persist account currency only if valid
          try {
            if (this.isValidCurrencyId(this.auxcurrency)) {
              localStorage.setItem('accountcurrency', String(this.auxcurrency));
            } else {
              console.warn(
                '[PaymentComponent] not persisting invalid auxcurrency (transfer):',
                this.auxcurrency,
              );
            }
          } catch (e) {
            console.warn(
              '[PaymentComponent] error persisting accountcurrency (transfer)',
              e,
            );
          }
          this.checkIfSendEmail();
          this.paymentOrder = {
            ...(this.paymentOrder || {}),
            paymentOrderStatus: 4,
          };
          this.openSuccessDialog();
          this.dialogRef.close(obj);
        },
        (error) => {
          this.process = true;
          this.mostrarSpinner = false;
          if (error.error == 'repeated reference') {
            this.matSnackBar.open(
              this.translate.instant('ReferenceNumberRepeted.texto'),
              '',
              {
                duration: 5000,
              },
            );
          } else {
            this.matSnackBar.open(
              this.translate.instant(
                'ErrorGeneratingPaymentContactSupport.texto',
              ),
              '',
              {
                duration: 5000,
              },
            );
          }
          console.log('Error al insertar el pago', error);
        },
      );
  }

  isMercantilActive() {
    try {
      const mercantilFlag = localStorage.getItem('MercantilButton');
      console.log(
        '[PaymentComponent][isMercantilActive] MercantilButton from localStorage =',
        mercantilFlag,
      );
      // Only show when explicitly set to 'true'; hide for any other value or when missing
      this.showMercantilButton = mercantilFlag === 'true';
      console.log(
        '[PaymentComponent][isMercantilActive] computed showMercantilButton =',
        this.showMercantilButton,
      );
    } catch (e) {
      console.warn(
        '[PaymentComponent][isMercantilActive] Failed to read MercantilButton from localStorage',
        e,
      );
      this.showMercantilButton = false;
    }
  }

  createMercantilTransaction() {
    if (!this.hasUsableRate()) {
      this.matSnackBar.open(
        this.translate.instant('ConversionError.texto'),
        '',
        {
          duration: 4000,
          verticalPosition: 'bottom',
          panelClass: ['text-danger'],
        },
      );
      this.process = true;
      return;
    }
    const envAny: any = environment as any;
    const serviceCenterId =
      this.paymentOrder?.serviceCenterId ||
      localStorage.getItem('scid') ||
      envAny.serviceCenterId ||
      '';
    const serviceRequestId = this.paymentOrder?.serviceRequestId || '';
    const paymentOrdersId = this.paymentOrderid || this.paymentOrder?.id || '';
    const contractNumber = this.paymentOrder?.correlative
      ? String(this.paymentOrder.correlative)
      : '';
    const contractDate = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
    const amount = this.getConvertedTotal();
    if (amount === this.getBaseTotal()) {
      this.matSnackBar.open(
        this.translate.instant('ConversionError.texto'),
        '',
        {
          duration: 3000,
          verticalPosition: 'bottom',
          panelClass: ['text-danger'],
        },
      );
      return;
    }
    const returnUrl = environment.returnUrl || 'https://www.google.com';
    console.log('[PaymentComponent] Preparing Mercantil transaction', {
      serviceCenterId,
      serviceRequestId,
      paymentOrdersId,
      contractNumber,
      amount,
      returnUrl,
    });
    this.mercantilPaymentService
      .getSettingsMobile(serviceCenterId, 3)
      .subscribe(
        (settings: any) => {
          const merchantid = settings?.entity?.dni;
          const integratorid = settings?.entity?.apiKey;
          const customerName = settings?.entity?.user;
          const transactionPayload = {
            amount: String(amount),
            customerName,
            returnUrl,
            merchantId: merchantid,
            contract: {
              contractNumber: String(contractNumber),
              contractDate,
            },
            trxType: 'compra',
            currency: 'ves',
            paymentConcepts: ['B2B'],
            paymentProcessDto: {
              paymentOrdersId,
              serviceCenterId,
              originId: serviceRequestId,
              ivaAmount: 0,
              islrAmount: 0,
              handlesTaxWithholdings: false,
              typeOfOriginPayment: 1,
              numberOfRechargesToProcess: null,
              amountOfTime: null,
              paymentProcessStatus: 0,
              paymentProcessType: 0,
              paymentExchangeRate: this.getPaymentExchangeRate(),
            },
          };
          console.log(
            '[PaymentComponent] Mercantil encrypt payload:',
            transactionPayload,
          );
          this.mercantilPaymentService
            .encryptPayment(transactionPayload)
            .subscribe(
              (transactionData: any) => {
                const baseUrl = environment.mercantilUrl;
                const url = `${baseUrl}/?merchantid=${merchantid}&transactiondata=${transactionData.transactionDate}&integratorid=${integratorid}`;
                console.log(
                  '[PaymentComponent] Redirecting to Mercantil URL:',
                  url,
                );
                // Close modal before navigation (same-page redirect)
                try {
                  this.dialogRef.close({ mercantilRedirect: true });
                } catch {}
                // Navigate in the same tab instead of opening a new one
                try {
                  window.location.href = url; // same-page navigation
                } catch (e) {
                  console.warn(
                    '[PaymentComponent] direct location.href failed, falling back to _self window.open',
                    e,
                  );
                  window.open(url, '_self');
                }
              },
              (err: any) => {
                console.error(
                  '[PaymentComponent] error encrypting Mercantil payment:',
                  err,
                );
              },
            );
        },
        (err: any) => {
          console.error(
            '[PaymentComponent] error fetching Mercantil settings:',
            err,
          );
        },
      );
  }

  PayWithCreditCard() {
    if (this.method !== 'credit') {
      console.warn(
        '[PaymentComponent] PayWithCreditCard invoked but method is not credit',
      );
      return;
    }
    if (!this.stripeCardRef) {
      console.error('[PaymentComponent] Stripe card component not available');
      this.matSnackBar.open(
        this.translate.instant('CardNotInitialized.texto'),
        '',
        { duration: 3000 },
      );
      return;
    }
    console.log('[PaymentComponent] Starting Stripe payment flow...');
    this.mostrarSpinner = true;

    const publishableKey =
      localStorage.getItem('stripePublishableKey') || 'NOT_SET';
    // IMPORTANT: Elements are created by the injected ngx-stripe instance (StripeService).
    // Always use the same instance that created the Element to call createToken.
    // Using a factory-created `Stripe` instance here will cause the IntegrationError seen in the console.
    const stripeClient = this.stripeService as any;
    if (this.stripe) {
      console.warn(
        '[PaymentComponent] A factory-created Stripe instance exists but will NOT be used to create the token because the Element was created by the injected StripeService. Using the same instance avoids IntegrationError.',
      );
    }
    console.log(
      '[PaymentComponent] using stripe client (injected StripeService) publishableKey:',
      publishableKey,
    );
    console.log(
      '[PaymentComponent] stripeCardRef.element:',
      (this.stripeCardRef as any)?.element,
    );

    this.stripeTokenService
      .testStripeApi(stripeClient, this.stripeCardRef, {} as any)
      .subscribe((tokenOrResult: any) => {
        console.log(
          '[PaymentComponent] raw token returned from stripeTokenService:',
          tokenOrResult,
        );
        // If the service returned an error object (e.g., { error: { message, decline_code, seller_message } })
        if (tokenOrResult && tokenOrResult.error) {
          this.mostrarSpinner = false;
          this.process = true;
          // Pass the Stripe error object through mostrarError to set stripeErrorCode/message
          this.mostrarError(tokenOrResult.error);
          this.errorflag = true;
          console.warn(
            '[PaymentComponent] Token creation failed with Stripe error',
          );
          return;
        }
        const token = tokenOrResult;
        const tokenId = typeof token === 'string' ? token : (token?.id ?? null);
        console.log('[PaymentComponent] normalized tokenId:', tokenId);
        if (!tokenId) {
          this.mostrarSpinner = false;
          this.process = true;
          this.matSnackBar.open(
            this.translate.instant('CompleteAllRequiredFields.texto'),
            '',
            {
              duration: 3000,
            },
          );
          this.errorflag = true;
          console.warn('[PaymentComponent] Token not generated or invalid');
          return;
        }
        this.errorflag = false;
        // For Stripe (credit card), we must send the base total amount (e.g. USD)
        // regardless of the selected currency toggle, to avoid charging the tasa-multiplied amount in USD.
        const value = this.getBaseTotal();

        const paymentPayload: any = {
          originId: this.paymentOrder?.serviceRequestId,
          serviceCenterId: localStorage.getItem('scid'),
          typeOfOriginPayment: 1, // credit card
          value: value,
          // Always use USD for Stripe if the original amount was in USD base.
          transactionCurrencyCode: 'USD',
          paymentExchangeRate: this.getPaymentExchangeRate(),
        };
        console.log('[PaymentComponent] Creating payment before linking card', {
          paymentPayload,
        });

        this.paymentService.createPayment(paymentPayload).subscribe(
          (paymentResponse: any) => {
            console.log('[PaymentComponent] payment created:', paymentResponse);
            // pass tokenId (string) to CrearTarjeta
            this.CrearTarjeta(paymentResponse, tokenId);
          },
          (e: any) => {
            this.mostrarSpinner = false;
            this.process = true;
            this.mostrarError(e);
            console.error('[PaymentComponent] error creating payment:', e);
          },
        );
      });
  }

  PayWithPaypal() {
    /*
    if (this.checkIfApplyTax()) {
      this.process = true;
      return;
    }
    let Total = this.getBaseTotal();

    Total = Total - this.getIvaPlusIslr();

    if (this.tasa == 0 && this.igtfFlag) {
      Total = Total + Total * this.igtfTax;
    }

    let MontoTotal = Total.toFixed(2);
    this.payPalConfig = {
      currency: 'USD', //'AWyVgUMTngY7gEW9zTar65R6Sb7-mfQ67S8pCsv3wPlPwGkvV8x7kYwAMyQToMVsa47_YxNKvrNnZdCE' this.paypalClientId
      clientId: this.paypalClientId,
      createOrderOnClient: (data) =>
        <ICreateOrderRequest>{
          intent: 'CAPTURE',
          purchase_units: [
            {
              amount: {
                currency_code: 'USD',
                value: MontoTotal.toString(),
              },
            },
          ],
        },
      advanced: {
        commit: 'true',
      },
      style: {
        label: 'paypal',
        layout: 'horizontal',
        color: 'blue',
      },
      onApprove: (data, actions) => {
        actions.order.get().then((det: any) => {
          this.montopago = det.purchase_units[0].amount.value;
          this.currency = det.purchase_units[0].amount.currency_code;
        });
      },
      onClientAuthorization: (det) => {
        console.log('AUT', det);
        var x = JSON.parse(JSON.stringify(det));
        this.transaccionId = x.purchase_units[0].payments.captures[0].id;
        this.montopago = x.purchase_units[0].amount.value;
        this.currency = x.purchase_units[0].amount.currency_code;
        this.payOrder();
      },
      onCancel: (data, actions) => {
        console.log('OnCancel', data, actions);
      },
      onError: (err) => {},
      onClick: (data, actions) => {
        console.log('onClick', data, actions);
      },
    };
  } */
  }

  private Validate(expreg: any, price: any) {
    const EXPREG = expreg;
    let evaluate = EXPREG.exec(price) == null ? true : false;
    return evaluate;
  }

  private openSuccessDialog() {
    if (this.successDialogOpened) return;
    this.successDialogOpened = true;

    // Execute Sidney Custom Flow
    try {
      const scid = localStorage.getItem('scid') || '';
      const serviceRequestId = this.paymentOrder?.externalDocument;
      if (scid && serviceRequestId) {
        this.sidneyCustomFlowService.executeSidneyCustomFlow(
          scid,
          serviceRequestId,
        );
      }
    } catch (e) {
      console.error(
        '[PaymentComponent] Error triggering Sidney custom flow in openSuccessDialog',
        e,
      );
    }

    try {
      this.dialog.open(SuccessPaymentDialogComponent, {
        disableClose: true,
        width: '360px',
      });
    } catch (e) {
      console.warn('[PaymentComponent] failed to open success dialog', e);
    }
  }
}
